(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec080"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec080"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gYLTL", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $c5c7678eaa7a093c$export$b3219800bda33a1f; });
$parcel$export(module.exports, "map", function () { return $c5c7678eaa7a093c$export$871de8747c9eaa88; });
$parcel$export(module.exports, "layers", function () { return $c5c7678eaa7a093c$export$7be255094ccdc533; });
$parcel$export(module.exports, "data", function () { return $c5c7678eaa7a093c$export$4051a07651545597; });
$parcel$export(module.exports, "timeline", function () { return $c5c7678eaa7a093c$export$cddc5598d4bb8461; });
$parcel$export(module.exports, "updateLayout", function () { return $c5c7678eaa7a093c$export$16101e34a0df23af; });
$parcel$export(module.exports, "sliderDisplay", function () { return $c5c7678eaa7a093c$export$b3a1d7f506ff6b39; });
$parcel$export(module.exports, "initSlides", function () { return $c5c7678eaa7a093c$export$95ec55fd5e34091c; });
$parcel$export(module.exports, "createSlides", function () { return $c5c7678eaa7a093c$export$a8c1a1328c9c7341; });
$parcel$export(module.exports, "displayNews", function () { return $c5c7678eaa7a093c$export$745c23925d1ed483; });
$parcel$export(module.exports, "displayWindFranceForm", function () { return $c5c7678eaa7a093c$export$fed338021986fa92; });
$parcel$export(module.exports, "logPageView", function () { return $c5c7678eaa7a093c$export$2d491819e027e29d; });
$parcel$export(module.exports, "isSpotContext", function () { return $c5c7678eaa7a093c$export$8fb5838cf0be4d4; });
$parcel$export(module.exports, "isEditMode", function () { return $c5c7678eaa7a093c$export$57957ca6633a6742; });
$parcel$export(module.exports, "currentActiveSpot", function () { return $c5c7678eaa7a093c$export$4d1458a60f10390e; });

var $fOKLR = parcelRequire("fOKLR");

var $j5Ozl = parcelRequire("j5Ozl");

var $dnPBs = parcelRequire("dnPBs");
var $c5c7678eaa7a093c$export$b3219800bda33a1f = {
    width: window.innerWidth,
    height: window.innerHeight - 120,
    mobile: window.innerWidth <= 768,
    edit: false
};
var $c5c7678eaa7a093c$export$b3890eb0ae9dca99 = {
    canvasScale: window.devicePixelRatio,
    liveCanvas: null,
    pauseRendering: false
};
var $c5c7678eaa7a093c$export$9ba38043771de2c2 = {
    activeCharts: {}
};
var $c5c7678eaa7a093c$export$871de8747c9eaa88 = {
    instance: null,
    refZoom: null,
    bgPoints: [],
    currentFocus: null,
    activeMap: "wm",
    popup: null,
    coastLine: null,
    windLayer: null,
    windBox: {},
    windWidth: null,
    windHeight: null,
    wavesLayer: null,
    wavesBox: {},
    wavesWidth: null,
    wavesHeight: null,
    rasterWidth: null,
    rasterHeight: null
};
var $c5c7678eaa7a093c$export$7be255094ccdc533 = {
    forecastsLayer: null,
    overlay: null,
    tiles: null,
    bgLayers: [],
    dataLayers: [
        "wind",
        "waves"
    ],
    activePoi: null,
    activeSpot: null
};
var $c5c7678eaa7a093c$export$4051a07651545597 = {
    coastData: null,
    // windData: [],
    timelineData: {},
    sensorsPolling: null
};
var $c5c7678eaa7a093c$export$cddc5598d4bb8461 = {
    timelineStep: 600,
    timelineSteps: null,
    timelineReference: null,
    timelineActiveStep: null,
    timelineActiveShortStep: null,
    timelineInterval: null,
    timelineSlider: null,
    timelinePosition: null,
    stepWidth: 10,
    cursorOffset: $c5c7678eaa7a093c$export$b3219800bda33a1f.width / 2.0 - (window.innerWidth <= 768 ? 0 : 232),
    details: false,
    detailsStepWidth: 5,
    detailsCursorOffset: $c5c7678eaa7a093c$export$b3219800bda33a1f.width / 2.0 - (window.innerWidth <= 768 ? 0 : 216),
    scrolling: false,
    moving: false,
    skipUpdate: true,
    keyBoardSetUp: false,
    setUp: false,
    hourLabel: document.querySelector("#timeline_hour"),
    dateLabel: document.querySelector("#timeline_date"),
    hoursCount: Math.floor((window.innerWidth / 2 - 256) / 60),
    hoursCountDetails: Math.floor((window.innerWidth / 2 - 240) / 30)
};
function $c5c7678eaa7a093c$export$16101e34a0df23af() {
    const isMobile = window.innerWidth <= 768, bottomMargin = isMobile ? 120 : 150;
    $c5c7678eaa7a093c$export$b3219800bda33a1f.width = window.innerWidth;
    $c5c7678eaa7a093c$export$b3219800bda33a1f.height = window.innerHeight - bottomMargin;
    $c5c7678eaa7a093c$export$b3890eb0ae9dca99.canvasScale = window.devicePixelRatio;
}
function $c5c7678eaa7a093c$export$b3a1d7f506ff6b39(id, opts) {
    const defaultOpts = {
        container: document.getElementById(id),
        items: 1,
        edgePadding: 0,
        gutter: 20,
        autoplayTimeout: 10000,
        autoplay: true,
        swipeAngle: false,
        speed: 1000,
        loop: true,
        nav: false,
        autoplayButtonOutput: false,
        autoplayButton: false,
        controls: false,
        responsive: {
            640: {
                items: 2
            },
            1024: {
                items: 3
            }
        }
    };
    return (0, $fOKLR.tns)({
        ...defaultOpts,
        ...opts || {}
    });
}
function $c5c7678eaa7a093c$export$95ec55fd5e34091c(completedSlide) {
    (0, $j5Ozl.loadAdvertisers)(completedSlide);
}
function $c5c7678eaa7a093c$export$a8c1a1328c9c7341(data, id) {
    let wrapper = document.getElementById(id), i;
    if (data.length > 0) for(i = 0; i < data.length; i++){
        let container = document.createElement("div"), imgWrapper;
        wrapper.append(container);
        if (data[i]["url"]) {
            imgWrapper = document.createElement("a");
            imgWrapper.target = "_blank";
            imgWrapper.href = data[i]["url"];
        } else imgWrapper = document.createElement("div");
        container.append(imgWrapper);
        let picture = document.createElement("img");
        picture.classList.add("img-responsive");
        picture.src = data[i]["path"];
        imgWrapper.append(picture);
    }
}
function $c5c7678eaa7a093c$export$745c23925d1ed483(timeout) {
    setTimeout(function() {
        (0, $dnPBs.default).show("news_modal", {
            disableScroll: true
        });
        if (document.querySelectorAll("#news_modal #news_slides img").length === 0) {
            $c5c7678eaa7a093c$export$a8c1a1328c9c7341((0, $j5Ozl.newsRefs), "news_slides");
            $c5c7678eaa7a093c$export$b3a1d7f506ff6b39("news_slides", {
                controls: true,
                controlsText: [
                    '<i class="far fa-chevron-circle-left"></i>',
                    '<i class="far fa-chevron-circle-right"></i>'
                ],
                nav: true,
                navPosition: "bottom",
                responsive: {
                    640: {
                        items: 1
                    },
                    1024: {
                        items: 1
                    }
                }
            });
            localStorage.setItem("news-22012025", new Date().getTime());
        }
    }, timeout);
}
function $c5c7678eaa7a093c$export$fed338021986fa92(timeout) {
    setTimeout(function() {
        (0, $dnPBs.default).show("form_modal", {
            disableScroll: true
        });
    }, timeout);
}
function $c5c7678eaa7a093c$export$2d491819e027e29d(lastRoute, path, title) {
    let firstPage = lastRoute === null;
    if (!firstPage) {
        _paq.push([
            "setCustomUrl",
            path
        ]);
        _paq.push([
            "setDocumentTitle",
            title
        ]);
        _paq.push([
            "trackPageView"
        ]);
    }
}
function $c5c7678eaa7a093c$export$8fb5838cf0be4d4() {
    console.debug(`isSpotContext - activeSpot: ${$c5c7678eaa7a093c$export$7be255094ccdc533.activeSpot?.ref} - edit: ${$c5c7678eaa7a093c$export$b3219800bda33a1f.edit}`);
    return $c5c7678eaa7a093c$export$7be255094ccdc533.activeSpot || $c5c7678eaa7a093c$export$b3219800bda33a1f.edit;
}
function $c5c7678eaa7a093c$export$57957ca6633a6742() {
    return $c5c7678eaa7a093c$export$b3219800bda33a1f.edit;
}
function $c5c7678eaa7a093c$export$4d1458a60f10390e() {
    return $c5c7678eaa7a093c$export$7be255094ccdc533.activeSpot;
}

});
parcelRegister("fOKLR", function(module, exports) {

$parcel$export(module.exports, "tns", function () { return $b83fce493f653d9f$export$51fe319e24d9d8c9; });
// Object.keys

var $4NViB = parcelRequire("4NViB");

var $9yHtX = parcelRequire("9yHtX");

var $b2MWu = parcelRequire("b2MWu");

var $gzKiH = parcelRequire("gzKiH");

var $LBcQ2 = parcelRequire("LBcQ2");

var $PI8R3 = parcelRequire("PI8R3");

var $6fCzg = parcelRequire("6fCzg");

var $9ahPU = parcelRequire("9ahPU");

var $jnIJF = parcelRequire("jnIJF");

var $jRsRU = parcelRequire("jRsRU");

var $je0lE = parcelRequire("je0lE");

var $1ZlSw = parcelRequire("1ZlSw");

var $h8JFb = parcelRequire("h8JFb");

var $bFwtC = parcelRequire("bFwtC");

var $8Vei7 = parcelRequire("8Vei7");

var $5Zhog = parcelRequire("5Zhog");

var $fH2Ol = parcelRequire("fH2Ol");

var $fkJZ2 = parcelRequire("fkJZ2");

var $6Hsm5 = parcelRequire("6Hsm5");

var $fCuOt = parcelRequire("fCuOt");

var $eazmc = parcelRequire("eazmc");

var $gCLCq = parcelRequire("gCLCq");

var $9y8Cf = parcelRequire("9y8Cf");

var $7bhjn = parcelRequire("7bhjn");

var $1CRAr = parcelRequire("1CRAr");

var $lRScj = parcelRequire("lRScj");

var $dcREA = parcelRequire("dcREA");

var $fwFwV = parcelRequire("fwFwV");

var $17sDF = parcelRequire("17sDF");

var $hude7 = parcelRequire("hude7");

var $78Ai4 = parcelRequire("78Ai4");

var $diLUe = parcelRequire("diLUe");

var $4YxDd = parcelRequire("4YxDd");

var $jhBP3 = parcelRequire("jhBP3");
if (!Object.keys) Object.keys = function(object) {
    var keys = [];
    for(var name in object)if (Object.prototype.hasOwnProperty.call(object, name)) keys.push(name);
    return keys;
};
// ChildNode.remove
if (!("remove" in Element.prototype)) Element.prototype.remove = function() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
var $b83fce493f653d9f$export$51fe319e24d9d8c9 = function(options) {
    options = (0, $b2MWu.extend)({
        container: ".slider",
        mode: "carousel",
        axis: "horizontal",
        items: 1,
        gutter: 0,
        edgePadding: 0,
        fixedWidth: false,
        autoWidth: false,
        viewportMax: false,
        slideBy: 1,
        center: false,
        controls: true,
        controlsPosition: "top",
        controlsText: [
            "prev",
            "next"
        ],
        controlsContainer: false,
        prevButton: false,
        nextButton: false,
        nav: true,
        navPosition: "top",
        navContainer: false,
        navAsThumbnails: false,
        arrowKeys: false,
        speed: 300,
        autoplay: false,
        autoplayPosition: "top",
        autoplayTimeout: 5000,
        autoplayDirection: "forward",
        autoplayText: [
            "start",
            "stop"
        ],
        autoplayHoverPause: false,
        autoplayButton: false,
        autoplayButtonOutput: true,
        autoplayResetOnVisibility: true,
        animateIn: "tns-fadeIn",
        animateOut: "tns-fadeOut",
        animateNormal: "tns-normal",
        animateDelay: false,
        loop: true,
        rewind: false,
        autoHeight: false,
        responsive: false,
        lazyload: false,
        lazyloadSelector: ".tns-lazy-img",
        touch: true,
        mouseDrag: false,
        swipeAngle: 15,
        nested: false,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        freezable: true,
        onInit: false,
        useLocalStorage: true,
        nonce: false
    }, options || {});
    var doc = document, win = window, KEYS = {
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        RIGHT: 39
    }, tnsStorage = {}, localStorageAccess = options.useLocalStorage;
    if (localStorageAccess) {
        // check browser version and local storage access
        var browserInfo = navigator.userAgent;
        var uid = new Date;
        try {
            tnsStorage = win.localStorage;
            if (tnsStorage) {
                tnsStorage.setItem(uid, uid);
                localStorageAccess = tnsStorage.getItem(uid) == uid;
                tnsStorage.removeItem(uid);
            } else localStorageAccess = false;
            if (!localStorageAccess) tnsStorage = {};
        } catch (e) {
            localStorageAccess = false;
        }
        if (localStorageAccess) {
            // remove storage when browser version changes
            if (tnsStorage["tnsApp"] && tnsStorage["tnsApp"] !== browserInfo) [
                "tC",
                "tPL",
                "tMQ",
                "tTf",
                "t3D",
                "tTDu",
                "tTDe",
                "tADu",
                "tADe",
                "tTE",
                "tAE"
            ].forEach(function(item) {
                tnsStorage.removeItem(item);
            });
            // update browserInfo
            localStorage["tnsApp"] = browserInfo;
        }
    }
    var CALC = tnsStorage["tC"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tC"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tC", (0, $6fCzg.calc)(), localStorageAccess), PERCENTAGELAYOUT = tnsStorage["tPL"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tPL"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tPL", (0, $9ahPU.percentageLayout)(), localStorageAccess), CSSMQ = tnsStorage["tMQ"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tMQ"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tMQ", (0, $jnIJF.mediaquerySupport)(), localStorageAccess), TRANSFORM = tnsStorage["tTf"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tTf"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tTf", (0, $fwFwV.whichProperty)("transform"), localStorageAccess), HAS3DTRANSFORMS = tnsStorage["t3D"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["t3D"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "t3D", (0, $17sDF.has3DTransforms)(TRANSFORM), localStorageAccess), TRANSITIONDURATION = tnsStorage["tTDu"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tTDu"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tTDu", (0, $fwFwV.whichProperty)("transitionDuration"), localStorageAccess), TRANSITIONDELAY = tnsStorage["tTDe"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tTDe"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tTDe", (0, $fwFwV.whichProperty)("transitionDelay"), localStorageAccess), ANIMATIONDURATION = tnsStorage["tADu"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tADu"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tADu", (0, $fwFwV.whichProperty)("animationDuration"), localStorageAccess), ANIMATIONDELAY = tnsStorage["tADe"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tADe"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tADe", (0, $fwFwV.whichProperty)("animationDelay"), localStorageAccess), TRANSITIONEND = tnsStorage["tTE"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tTE"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tTE", (0, $hude7.getEndProperty)(TRANSITIONDURATION, "Transition"), localStorageAccess), ANIMATIONEND = tnsStorage["tAE"] ? (0, $gzKiH.checkStorageValue)(tnsStorage["tAE"]) : (0, $LBcQ2.setLocalStorage)(tnsStorage, "tAE", (0, $hude7.getEndProperty)(ANIMATIONDURATION, "Animation"), localStorageAccess);
    // get element nodes from selectors
    var supportConsoleWarn = win.console && typeof win.console.warn === "function", tnsList = [
        "container",
        "controlsContainer",
        "prevButton",
        "nextButton",
        "navContainer",
        "autoplayButton"
    ], optionsElements = {};
    tnsList.forEach(function(item) {
        if (typeof options[item] === "string") {
            var str = options[item], el = doc.querySelector(str);
            optionsElements[item] = str;
            if (el && el.nodeName) options[item] = el;
            else {
                if (supportConsoleWarn) console.warn("Can't find", options[item]);
                return;
            }
        }
    });
    // make sure at least 1 slide
    if (options.container.children.length < 1) {
        if (supportConsoleWarn) console.warn("No slides found in", options.container);
        return;
    }
    // update options
    var responsive = options.responsive, nested = options.nested, carousel = options.mode === "carousel" ? true : false;
    if (responsive) {
        // apply responsive[0] to options and remove it
        if (0 in responsive) {
            options = (0, $b2MWu.extend)(options, responsive[0]);
            delete responsive[0];
        }
        var responsiveTem = {};
        for(var key in responsive){
            var val = responsive[key];
            // update responsive
            // from: 300: 2
            // to:
            //   300: {
            //     items: 2
            //   }
            val = typeof val === "number" ? {
                items: val
            } : val;
            responsiveTem[key] = val;
        }
        responsive = responsiveTem;
        responsiveTem = null;
    }
    // update options
    function updateOptions(obj) {
        for(var key in obj){
            if (!carousel) {
                if (key === "slideBy") obj[key] = "page";
                if (key === "edgePadding") obj[key] = false;
                if (key === "autoHeight") obj[key] = false;
            }
            // update responsive options
            if (key === "responsive") updateOptions(obj[key]);
        }
    }
    if (!carousel) updateOptions(options);
    // === define and set variables ===
    if (!carousel) {
        options.axis = "horizontal";
        options.slideBy = "page";
        options.edgePadding = false;
        var animateIn = options.animateIn, animateOut = options.animateOut, animateDelay = options.animateDelay, animateNormal = options.animateNormal;
    }
    var horizontal = options.axis === "horizontal" ? true : false, outerWrapper = doc.createElement("div"), innerWrapper = doc.createElement("div"), middleWrapper, container = options.container, containerParent = container.parentNode, containerHTML = container.outerHTML, slideItems = container.children, slideCount = slideItems.length, breakpointZone, windowWidth = getWindowWidth(), isOn = false;
    if (responsive) setBreakpointZone();
    if (carousel) container.className += " tns-vpfix";
    // fixedWidth: viewport > rightBoundary > indexMax
    var autoWidth = options.autoWidth, fixedWidth = getOption("fixedWidth"), edgePadding = getOption("edgePadding"), gutter = getOption("gutter"), viewport = getViewportWidth(), center = getOption("center"), items = !autoWidth ? Math.floor(getOption("items")) : 1, slideBy = getOption("slideBy"), viewportMax = options.viewportMax || options.fixedWidthViewportWidth, arrowKeys = getOption("arrowKeys"), speed = getOption("speed"), rewind = options.rewind, loop = rewind ? false : options.loop, autoHeight = getOption("autoHeight"), controls = getOption("controls"), controlsText = getOption("controlsText"), nav = getOption("nav"), touch = getOption("touch"), mouseDrag = getOption("mouseDrag"), autoplay = getOption("autoplay"), autoplayTimeout = getOption("autoplayTimeout"), autoplayText = getOption("autoplayText"), autoplayHoverPause = getOption("autoplayHoverPause"), autoplayResetOnVisibility = getOption("autoplayResetOnVisibility"), sheet = (0, $jRsRU.createStyleSheet)(null, getOption("nonce")), lazyload = options.lazyload, lazyloadSelector = options.lazyloadSelector, slidePositions, slideItemsOut = [], cloneCount = loop ? getCloneCountForLoop() : 0, slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2, hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false, rightBoundary = fixedWidth ? getRightBoundary() : null, updateIndexBeforeTransform = !carousel || !loop ? true : false, // transform
    transformAttr = horizontal ? "left" : "top", transformPrefix = "", transformPostfix = "", // index
    getIndexMax = function() {
        if (fixedWidth) return function() {
            return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
        else if (autoWidth) return function() {
            for(var i = 0; i < slideCountNew; i++){
                if (slidePositions[i] >= -rightBoundary) return i;
            }
        };
        else return function() {
            if (center && carousel && !loop) return slideCount - 1;
            else return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
        };
    }(), index = getStartIndex(getOption("startIndex")), indexCached = index, displayIndex = getCurrentSlide(), indexMin = 0, indexMax = !autoWidth ? getIndexMax() : null, // resize
    resizeTimer, preventActionWhenRunning = options.preventActionWhenRunning, swipeAngle = options.swipeAngle, moveDirectionExpected = swipeAngle ? "?" : true, running = false, onInit = options.onInit, events = new (0, $4YxDd.Events)(), // id, class
    newContainerClasses = " tns-slider tns-" + options.mode, slideId = container.id || (0, $PI8R3.getSlideId)(), disable = getOption("disable"), disabled = false, freezable = options.freezable, freeze = freezable && !autoWidth ? getFreeze() : false, frozen = false, controlsEvents = {
        "click": onControlsClick,
        "keydown": onControlsKeydown
    }, navEvents = {
        "click": onNavClick,
        "keydown": onNavKeydown
    }, hoverEvents = {
        "mouseover": mouseoverPause,
        "mouseout": mouseoutRestart
    }, visibilityEvent = {
        "visibilitychange": onVisibilityChange
    }, docmentKeydownEvent = {
        "keydown": onDocumentKeydown
    }, touchEvents = {
        "touchstart": onPanStart,
        "touchmove": onPanMove,
        "touchend": onPanEnd,
        "touchcancel": onPanEnd
    }, dragEvents = {
        "mousedown": onPanStart,
        "mousemove": onPanMove,
        "mouseup": onPanEnd,
        "mouseleave": onPanEnd
    }, hasControls = hasOption("controls"), hasNav = hasOption("nav"), navAsThumbnails = autoWidth ? true : options.navAsThumbnails, hasAutoplay = hasOption("autoplay"), hasTouch = hasOption("touch"), hasMouseDrag = hasOption("mouseDrag"), slideActiveClass = "tns-slide-active", slideClonedClass = "tns-slide-cloned", imgCompleteClass = "tns-complete", imgEvents = {
        "load": onImgLoaded,
        "error": onImgFailed
    }, imgsComplete, liveregionCurrent, preventScroll = options.preventScrollOnTouch === "force" ? true : false;
    // controls
    if (hasControls) var controlsContainer = options.controlsContainer, controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : "", prevButton = options.prevButton, nextButton = options.nextButton, prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : "", nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : "", prevIsButton, nextIsButton;
    // nav
    if (hasNav) var navContainer = options.navContainer, navContainerHTML = options.navContainer ? options.navContainer.outerHTML : "", navItems, pages = autoWidth ? slideCount : getPages(), pagesCached = 0, navClicked = -1, navCurrentIndex = getCurrentNavIndex(), navCurrentIndexCached = navCurrentIndex, navActiveClass = "tns-nav-active", navStr = "Carousel Page ", navStrCurrent = " (Current Slide)";
    // autoplay
    if (hasAutoplay) var autoplayDirection = options.autoplayDirection === "forward" ? 1 : -1, autoplayButton = options.autoplayButton, autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : "", autoplayHtmlStrings = [
        "<span class='tns-visually-hidden'>",
        " animation</span>"
    ], autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused;
    if (hasTouch || hasMouseDrag) var initPosition = {}, lastPosition = {}, translateInit, disX, disY, panStart = false, rafIndex, getDist = horizontal ? function(a, b) {
        return a.x - b.x;
    } : function(a, b) {
        return a.y - b.y;
    };
    // disable slider when slidecount <= items
    if (!autoWidth) resetVariblesWhenDisable(disable || freeze);
    if (TRANSFORM) {
        transformAttr = TRANSFORM;
        transformPrefix = "translate";
        if (HAS3DTRANSFORMS) {
            transformPrefix += horizontal ? "3d(" : "3d(0px, ";
            transformPostfix = horizontal ? ", 0px, 0px)" : ", 0px)";
        } else {
            transformPrefix += horizontal ? "X(" : "Y(";
            transformPostfix = ")";
        }
    }
    if (carousel) container.className = container.className.replace("tns-vpfix", "");
    initStructure();
    initSheet();
    initSliderTransform();
    // === COMMON FUNCTIONS === //
    function resetVariblesWhenDisable(condition) {
        if (condition) controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
    function getCurrentSlide() {
        var tem = carousel ? index - cloneCount : index;
        while(tem < 0)tem += slideCount;
        return tem % slideCount + 1;
    }
    function getStartIndex(ind) {
        ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
        return carousel ? ind + cloneCount : ind;
    }
    function getAbsIndex(i) {
        if (i == null) i = index;
        if (carousel) i -= cloneCount;
        while(i < 0)i += slideCount;
        return Math.floor(i % slideCount);
    }
    function getCurrentNavIndex() {
        var absIndex = getAbsIndex(), result;
        result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items);
        // set active nav to the last one when reaches the right edge
        if (!loop && carousel && index === indexMax) result = pages - 1;
        return result;
    }
    function getItemsMax() {
        // fixedWidth or autoWidth while viewportMax is not available
        if (autoWidth || fixedWidth && !viewportMax) return slideCount - 1;
        else {
            var str = fixedWidth ? "fixedWidth" : "items", arr = [];
            if (fixedWidth || options[str] < slideCount) arr.push(options[str]);
            if (responsive) for(var bp in responsive){
                var tem = responsive[bp][str];
                if (tem && (fixedWidth || tem < slideCount)) arr.push(tem);
            }
            if (!arr.length) arr.push(0);
            return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
        }
    }
    function getCloneCountForLoop() {
        var itemsMax = getItemsMax(), result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
        result = Math.max(itemsMax, result);
        return hasOption("edgePadding") ? result + 1 : result;
    }
    function getWindowWidth() {
        return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }
    function getInsertPosition(pos) {
        return pos === "top" ? "afterbegin" : "beforeend";
    }
    function getClientWidth(el) {
        if (el == null) return;
        var div = doc.createElement("div"), rect, width;
        el.appendChild(div);
        rect = div.getBoundingClientRect();
        width = rect.right - rect.left;
        div.remove();
        return width || getClientWidth(el.parentNode);
    }
    function getViewportWidth() {
        var gap = edgePadding ? edgePadding * 2 - gutter : 0;
        return getClientWidth(containerParent) - gap;
    }
    function hasOption(item) {
        if (options[item]) return true;
        else {
            if (responsive) for(var bp in responsive){
                if (responsive[bp][item]) return true;
            }
            return false;
        }
    }
    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    function getOption(item, ww) {
        if (ww == null) ww = windowWidth;
        if (item === "items" && fixedWidth) return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
        else {
            var result = options[item];
            if (responsive) for(var bp in responsive){
                // bp: convert string to number
                if (ww >= parseInt(bp)) {
                    if (item in responsive[bp]) result = responsive[bp][item];
                }
            }
            if (item === "slideBy" && result === "page") result = getOption("items");
            if (!carousel && (item === "slideBy" || item === "items")) result = Math.floor(result);
            return result;
        }
    }
    function getSlideMarginLeft(i) {
        return CALC ? CALC + "(" + i * 100 + "% / " + slideCountNew + ")" : i * 100 / slideCountNew + "%";
    }
    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
        var str = "";
        if (edgePaddingTem !== undefined) {
            var gap = edgePaddingTem;
            if (gutterTem) gap -= gutterTem;
            str = horizontal ? "margin: 0 " + gap + "px 0 " + edgePaddingTem + "px;" : "margin: " + edgePaddingTem + "px 0 " + gap + "px 0;";
        } else if (gutterTem && !fixedWidthTem) {
            var gutterTemUnit = "-" + gutterTem + "px", dir = horizontal ? gutterTemUnit + " 0 0" : "0 " + gutterTemUnit + " 0";
            str = "margin: 0 " + dir + ";";
        }
        if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) str += getTransitionDurationStyle(speedTem);
        return str;
    }
    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
        if (fixedWidthTem) return (fixedWidthTem + gutterTem) * slideCountNew + "px";
        else return CALC ? CALC + "(" + slideCountNew * 100 + "% / " + itemsTem + ")" : slideCountNew * 100 / itemsTem + "%";
    }
    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
        var width;
        if (fixedWidthTem) width = fixedWidthTem + gutterTem + "px";
        else {
            if (!carousel) itemsTem = Math.floor(itemsTem);
            var dividend = carousel ? slideCountNew : itemsTem;
            width = CALC ? CALC + "(100% / " + dividend + ")" : 100 / dividend + "%";
        }
        width = "width:" + width;
        // inner slider: overwrite outer slider styles
        return nested !== "inner" ? width + ";" : width + " !important;";
    }
    function getSlideGutterStyle(gutterTem) {
        var str = "";
        // gutter maybe interger || 0
        // so can't use 'if (gutter)'
        if (gutterTem !== false) {
            var prop = horizontal ? "padding-" : "margin-", dir = horizontal ? "right" : "bottom";
            str = prop + dir + ": " + gutterTem + "px;";
        }
        return str;
    }
    function getCSSPrefix(name, num) {
        var prefix = name.substring(0, name.length - num).toLowerCase();
        if (prefix) prefix = "-" + prefix + "-";
        return prefix;
    }
    function getTransitionDurationStyle(speed) {
        return getCSSPrefix(TRANSITIONDURATION, 18) + "transition-duration:" + speed / 1000 + "s;";
    }
    function getAnimationDurationStyle(speed) {
        return getCSSPrefix(ANIMATIONDURATION, 17) + "animation-duration:" + speed / 1000 + "s;";
    }
    function initStructure() {
        var classOuter = "tns-outer", classInner = "tns-inner", hasGutter = hasOption("gutter");
        outerWrapper.className = classOuter;
        innerWrapper.className = classInner;
        outerWrapper.id = slideId + "-ow";
        innerWrapper.id = slideId + "-iw";
        // set container properties
        if (container.id === "") container.id = slideId;
        newContainerClasses += PERCENTAGELAYOUT || autoWidth ? " tns-subpixel" : " tns-no-subpixel";
        newContainerClasses += CALC ? " tns-calc" : " tns-no-calc";
        if (autoWidth) newContainerClasses += " tns-autowidth";
        newContainerClasses += " tns-" + options.axis;
        container.className += newContainerClasses;
        // add constrain layer for carousel
        if (carousel) {
            middleWrapper = doc.createElement("div");
            middleWrapper.id = slideId + "-mw";
            middleWrapper.className = "tns-ovh";
            outerWrapper.appendChild(middleWrapper);
            middleWrapper.appendChild(innerWrapper);
        } else outerWrapper.appendChild(innerWrapper);
        if (autoHeight) {
            var wp = middleWrapper ? middleWrapper : innerWrapper;
            wp.className += " tns-ah";
        }
        containerParent.insertBefore(outerWrapper, container);
        innerWrapper.appendChild(container);
        // add id, class, aria attributes
        // before clone slides
        (0, $5Zhog.forEach)(slideItems, function(item, i) {
            (0, $fkJZ2.addClass)(item, "tns-item");
            if (!item.id) item.id = slideId + "-item" + i;
            if (!carousel && animateNormal) (0, $fkJZ2.addClass)(item, animateNormal);
            (0, $gCLCq.setAttrs)(item, {
                "aria-hidden": "true",
                "tabindex": "-1"
            });
        });
        // ## clone slides
        // carousel: n + slides + n
        // gallery:      slides + n
        if (cloneCount) {
            var fragmentBefore = doc.createDocumentFragment(), fragmentAfter = doc.createDocumentFragment();
            for(var j = cloneCount; j--;){
                var num = j % slideCount, cloneFirst = slideItems[num].cloneNode(true);
                (0, $fkJZ2.addClass)(cloneFirst, slideClonedClass);
                (0, $9y8Cf.removeAttrs)(cloneFirst, "id");
                fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);
                if (carousel) {
                    var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
                    (0, $fkJZ2.addClass)(cloneLast, slideClonedClass);
                    (0, $9y8Cf.removeAttrs)(cloneLast, "id");
                    fragmentBefore.appendChild(cloneLast);
                }
            }
            container.insertBefore(fragmentBefore, container.firstChild);
            container.appendChild(fragmentAfter);
            slideItems = container.children;
        }
    }
    function initSliderTransform() {
        // ## images loaded/failed
        if (hasOption("autoHeight") || autoWidth || !horizontal) {
            var imgs = container.querySelectorAll("img");
            // add img load event listener
            (0, $5Zhog.forEach)(imgs, function(img) {
                var src = img.src;
                if (!lazyload) {
                    // not data img
                    if (src && src.indexOf("data:image") < 0) {
                        img.src = "";
                        (0, $78Ai4.addEvents)(img, imgEvents);
                        (0, $fkJZ2.addClass)(img, "loading");
                        img.src = src;
                    // data img
                    } else imgLoaded(img);
                }
            });
            // set imgsComplete
            (0, $4NViB.raf)(function() {
                imgsLoadedCheck((0, $7bhjn.arrayFromNodeList)(imgs), function() {
                    imgsComplete = true;
                });
            });
            // reset imgs for auto height: check visible imgs only
            if (hasOption("autoHeight")) imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
            lazyload ? initSliderTransformStyleCheck() : (0, $4NViB.raf)(function() {
                imgsLoadedCheck((0, $7bhjn.arrayFromNodeList)(imgs), initSliderTransformStyleCheck);
            });
        } else {
            // set container transform property
            if (carousel) doContainerTransformSilent();
            // update slider tools and events
            initTools();
            initEvents();
        }
    }
    function initSliderTransformStyleCheck() {
        if (autoWidth && slideCount > 1) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function stylesApplicationCheck() {
                var left = slideItems[num].getBoundingClientRect().left;
                var right = slideItems[num - 1].getBoundingClientRect().right;
                Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function() {
                    stylesApplicationCheck();
                }, 16);
            })();
        } else initSliderTransformCore();
    }
    function initSliderTransformCore() {
        // run Fn()s which are rely on image loading
        if (!horizontal || autoWidth) {
            setSlidePositions();
            if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) freeze = getFreeze();
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
            } else updateContentWrapperHeight();
        }
        // set container transform property
        if (carousel) doContainerTransformSilent();
        // update slider tools and events
        initTools();
        initEvents();
    }
    function initSheet() {
        // gallery:
        // set animation classes and left value for gallery slider
        if (!carousel) for(var i = index, l = index + Math.min(slideCount, items); i < l; i++){
            var item = slideItems[i];
            item.style.left = (i - index) * 100 / items + "%";
            (0, $fkJZ2.addClass)(item, animateIn);
            (0, $6Hsm5.removeClass)(item, animateNormal);
        }
        // #### LAYOUT
        // ## INLINE-BLOCK VS FLOAT
        // ## PercentageLayout:
        // slides: inline-block
        // remove blank space between slides by set font-size: 0
        // ## Non PercentageLayout:
        // slides: float
        //         margin-right: -100%
        //         margin-left: ~
        // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
        if (horizontal) {
            if (PERCENTAGELAYOUT || autoWidth) {
                (0, $je0lE.addCSSRule)(sheet, "#" + slideId + " > .tns-item", "font-size:" + win.getComputedStyle(slideItems[0]).fontSize + ";", (0, $h8JFb.getCssRulesLength)(sheet));
                (0, $je0lE.addCSSRule)(sheet, "#" + slideId, "font-size:0;", (0, $h8JFb.getCssRulesLength)(sheet));
            } else if (carousel) (0, $5Zhog.forEach)(slideItems, function(slide, i) {
                slide.style.marginLeft = getSlideMarginLeft(i);
            });
        }
        // ## BASIC STYLES
        if (CSSMQ) {
            // middle wrapper style
            if (TRANSITIONDURATION) {
                var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : "";
                (0, $je0lE.addCSSRule)(sheet, "#" + slideId + "-mw", str, (0, $h8JFb.getCssRulesLength)(sheet));
            }
            // inner wrapper styles
            str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
            (0, $je0lE.addCSSRule)(sheet, "#" + slideId + "-iw", str, (0, $h8JFb.getCssRulesLength)(sheet));
            // container styles
            if (carousel) {
                str = horizontal && !autoWidth ? "width:" + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ";" : "";
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                (0, $je0lE.addCSSRule)(sheet, "#" + slideId, str, (0, $h8JFb.getCssRulesLength)(sheet));
            }
            // slide styles
            str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : "";
            if (options.gutter) str += getSlideGutterStyle(options.gutter);
            // set gallery items transition-duration
            if (!carousel) {
                if (TRANSITIONDURATION) str += getTransitionDurationStyle(speed);
                if (ANIMATIONDURATION) str += getAnimationDurationStyle(speed);
            }
            if (str) (0, $je0lE.addCSSRule)(sheet, "#" + slideId + " > .tns-item", str, (0, $h8JFb.getCssRulesLength)(sheet));
        // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)
        } else {
            // middle wrapper styles
            update_carousel_transition_duration();
            // inner wrapper styles
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight);
            // container styles
            if (carousel && horizontal && !autoWidth) container.style.width = getContainerWidth(fixedWidth, gutter, items);
            // slide styles
            var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : "";
            if (gutter) str += getSlideGutterStyle(gutter);
            // append to the last line
            if (str) (0, $je0lE.addCSSRule)(sheet, "#" + slideId + " > .tns-item", str, (0, $h8JFb.getCssRulesLength)(sheet));
        }
        // ## MEDIAQUERIES
        if (responsive && CSSMQ) for(var bp in responsive){
            // bp: convert string to number
            bp = parseInt(bp);
            var opts = responsive[bp], str = "", middleWrapperStr = "", innerWrapperStr = "", containerStr = "", slideStr = "", itemsBP = !autoWidth ? getOption("items", bp) : null, fixedWidthBP = getOption("fixedWidth", bp), speedBP = getOption("speed", bp), edgePaddingBP = getOption("edgePadding", bp), autoHeightBP = getOption("autoHeight", bp), gutterBP = getOption("gutter", bp);
            // middle wrapper string
            if (TRANSITIONDURATION && middleWrapper && getOption("autoHeight", bp) && "speed" in opts) middleWrapperStr = "#" + slideId + "-mw{" + getTransitionDurationStyle(speedBP) + "}";
            // inner wrapper string
            if ("edgePadding" in opts || "gutter" in opts) innerWrapperStr = "#" + slideId + "-iw{" + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + "}";
            // container string
            if (carousel && horizontal && !autoWidth && ("fixedWidth" in opts || "items" in opts || fixedWidth && "gutter" in opts)) containerStr = "width:" + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ";";
            if (TRANSITIONDURATION && "speed" in opts) containerStr += getTransitionDurationStyle(speedBP);
            if (containerStr) containerStr = "#" + slideId + "{" + containerStr + "}";
            // slide string
            if ("fixedWidth" in opts || fixedWidth && "gutter" in opts || !carousel && "items" in opts) slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
            if ("gutter" in opts) slideStr += getSlideGutterStyle(gutterBP);
            // set gallery items transition-duration
            if (!carousel && "speed" in opts) {
                if (TRANSITIONDURATION) slideStr += getTransitionDurationStyle(speedBP);
                if (ANIMATIONDURATION) slideStr += getAnimationDurationStyle(speedBP);
            }
            if (slideStr) slideStr = "#" + slideId + " > .tns-item{" + slideStr + "}";
            // add up
            str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;
            if (str) sheet.insertRule("@media (min-width: " + bp / 16 + "em) {" + str + "}", sheet.cssRules.length);
        }
    }
    function initTools() {
        // == slides ==
        updateSlideStatus();
        // == live region ==
        outerWrapper.insertAdjacentHTML("afterbegin", '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + "</span>  of " + slideCount + "</div>");
        liveregionCurrent = outerWrapper.querySelector(".tns-liveregion .current");
        // == autoplayInit ==
        if (hasAutoplay) {
            var txt = autoplay ? "stop" : "start";
            if (autoplayButton) (0, $gCLCq.setAttrs)(autoplayButton, {
                "data-action": txt
            });
            else if (options.autoplayButtonOutput) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + "</button>");
                autoplayButton = outerWrapper.querySelector("[data-action]");
            }
            // add event
            if (autoplayButton) (0, $78Ai4.addEvents)(autoplayButton, {
                "click": toggleAutoplay
            });
            if (autoplay) {
                startAutoplay();
                if (autoplayHoverPause) (0, $78Ai4.addEvents)(container, hoverEvents);
                if (autoplayResetOnVisibility) (0, $78Ai4.addEvents)(container, visibilityEvent);
            }
        }
        // == navInit ==
        if (hasNav) {
            var initIndex = !carousel ? 0 : cloneCount;
            // customized nav
            // will not hide the navs in case they're thumbnails
            if (navContainer) {
                (0, $gCLCq.setAttrs)(navContainer, {
                    "aria-label": "Carousel Pagination"
                });
                navItems = navContainer.children;
                (0, $5Zhog.forEach)(navItems, function(item, i) {
                    (0, $gCLCq.setAttrs)(item, {
                        "data-nav": i,
                        "tabindex": "-1",
                        "aria-label": navStr + (i + 1),
                        "aria-controls": slideId
                    });
                });
            // generated nav
            } else {
                var navHtml = "", hiddenStr = navAsThumbnails ? "" : 'style="display:none"';
                for(var i = 0; i < slideCount; i++)// hide nav items by default
                navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
                navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + "</div>";
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
                navContainer = outerWrapper.querySelector(".tns-nav");
                navItems = navContainer.children;
            }
            updateNavVisibility();
            // add transition
            if (TRANSITIONDURATION) {
                var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(), str = "transition: all " + speed / 1000 + "s";
                if (prefix) str = "-" + prefix + "-" + str;
                (0, $je0lE.addCSSRule)(sheet, "[aria-controls^=" + slideId + "-item]", str, (0, $h8JFb.getCssRulesLength)(sheet));
            }
            (0, $gCLCq.setAttrs)(navItems[navCurrentIndex], {
                "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
            });
            (0, $9y8Cf.removeAttrs)(navItems[navCurrentIndex], "tabindex");
            (0, $fkJZ2.addClass)(navItems[navCurrentIndex], navActiveClass);
            // add events
            (0, $78Ai4.addEvents)(navContainer, navEvents);
        }
        // == controlsInit ==
        if (hasControls) {
            if (!controlsContainer && (!prevButton || !nextButton)) {
                outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + "</button></div>");
                controlsContainer = outerWrapper.querySelector(".tns-controls");
            }
            if (!prevButton || !nextButton) {
                prevButton = controlsContainer.children[0];
                nextButton = controlsContainer.children[1];
            }
            if (options.controlsContainer) (0, $gCLCq.setAttrs)(controlsContainer, {
                "aria-label": "Carousel Navigation",
                "tabindex": "0"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) (0, $gCLCq.setAttrs)([
                prevButton,
                nextButton
            ], {
                "aria-controls": slideId,
                "tabindex": "-1"
            });
            if (options.controlsContainer || options.prevButton && options.nextButton) {
                (0, $gCLCq.setAttrs)(prevButton, {
                    "data-controls": "prev"
                });
                (0, $gCLCq.setAttrs)(nextButton, {
                    "data-controls": "next"
                });
            }
            prevIsButton = isButton(prevButton);
            nextIsButton = isButton(nextButton);
            updateControlsStatus();
            // add events
            if (controlsContainer) (0, $78Ai4.addEvents)(controlsContainer, controlsEvents);
            else {
                (0, $78Ai4.addEvents)(prevButton, controlsEvents);
                (0, $78Ai4.addEvents)(nextButton, controlsEvents);
            }
        }
        // hide tools if needed
        disableUI();
    }
    function initEvents() {
        // add events
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $78Ai4.addEvents)(container, eve);
        }
        if (touch) (0, $78Ai4.addEvents)(container, touchEvents, options.preventScrollOnTouch);
        if (mouseDrag) (0, $78Ai4.addEvents)(container, dragEvents);
        if (arrowKeys) (0, $78Ai4.addEvents)(doc, docmentKeydownEvent);
        if (nested === "inner") events.on("outerResized", function() {
            resizeTasks();
            events.emit("innerLoaded", info());
        });
        else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) (0, $78Ai4.addEvents)(win, {
            "resize": onResize
        });
        if (autoHeight) {
            if (nested === "outer") events.on("innerLoaded", doAutoHeight);
            else if (!disable) doAutoHeight();
        }
        doLazyLoad();
        if (disable) disableSlider();
        else if (freeze) freezeSlider();
        events.on("indexChanged", additionalUpdates);
        if (nested === "inner") events.emit("innerLoaded", info());
        if (typeof onInit === "function") onInit(info());
        isOn = true;
    }
    function destroy() {
        // sheet
        sheet.disabled = true;
        if (sheet.ownerNode) sheet.ownerNode.remove();
        // remove win event listeners
        (0, $diLUe.removeEvents)(win, {
            "resize": onResize
        });
        // arrowKeys, controls, nav
        if (arrowKeys) (0, $diLUe.removeEvents)(doc, docmentKeydownEvent);
        if (controlsContainer) (0, $diLUe.removeEvents)(controlsContainer, controlsEvents);
        if (navContainer) (0, $diLUe.removeEvents)(navContainer, navEvents);
        // autoplay
        (0, $diLUe.removeEvents)(container, hoverEvents);
        (0, $diLUe.removeEvents)(container, visibilityEvent);
        if (autoplayButton) (0, $diLUe.removeEvents)(autoplayButton, {
            "click": toggleAutoplay
        });
        if (autoplay) clearInterval(autoplayTimer);
        // container
        if (carousel && TRANSITIONEND) {
            var eve = {};
            eve[TRANSITIONEND] = onTransitionEnd;
            (0, $diLUe.removeEvents)(container, eve);
        }
        if (touch) (0, $diLUe.removeEvents)(container, touchEvents);
        if (mouseDrag) (0, $diLUe.removeEvents)(container, dragEvents);
        // cache Object values in options && reset HTML
        var htmlList = [
            containerHTML,
            controlsContainerHTML,
            prevButtonHTML,
            nextButtonHTML,
            navContainerHTML,
            autoplayButtonHTML
        ];
        tnsList.forEach(function(item, i) {
            var el = item === "container" ? outerWrapper : options[item];
            if (typeof el === "object" && el) {
                var prevEl = el.previousElementSibling ? el.previousElementSibling : false, parentEl = el.parentNode;
                el.outerHTML = htmlList[i];
                options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
            }
        });
        // reset variables
        tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
        // check variables
        // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });
        for(var a in this)if (a !== "rebuild") this[a] = null;
        isOn = false;
    }
    // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal
    function onResize(e) {
        (0, $4NViB.raf)(function() {
            resizeTasks(getEvent(e));
        });
    }
    function resizeTasks(e) {
        if (!isOn) return;
        if (nested === "outer") events.emit("outerResized", info(e));
        windowWidth = getWindowWidth();
        var bpChanged, breakpointZoneTem = breakpointZone, needContainerTransform = false;
        if (responsive) {
            setBreakpointZone();
            bpChanged = breakpointZoneTem !== breakpointZone;
            // if (hasRightDeadZone) { needContainerTransform = true; } // *?
            if (bpChanged) events.emit("newBreakpointStart", info(e));
        }
        var indChanged, itemsChanged, itemsTem = items, disableTem = disable, freezeTem = freeze, arrowKeysTem = arrowKeys, controlsTem = controls, navTem = nav, touchTem = touch, mouseDragTem = mouseDrag, autoplayTem = autoplay, autoplayHoverPauseTem = autoplayHoverPause, autoplayResetOnVisibilityTem = autoplayResetOnVisibility, indexTem = index;
        if (bpChanged) {
            var fixedWidthTem = fixedWidth, autoHeightTem = autoHeight, controlsTextTem = controlsText, centerTem = center, autoplayTextTem = autoplayText;
            if (!CSSMQ) var gutterTem = gutter, edgePaddingTem = edgePadding;
        }
        // get option:
        // fixed width: viewport, fixedWidth, gutter => items
        // others: window width => all variables
        // all: items => slideBy
        arrowKeys = getOption("arrowKeys");
        controls = getOption("controls");
        nav = getOption("nav");
        touch = getOption("touch");
        center = getOption("center");
        mouseDrag = getOption("mouseDrag");
        autoplay = getOption("autoplay");
        autoplayHoverPause = getOption("autoplayHoverPause");
        autoplayResetOnVisibility = getOption("autoplayResetOnVisibility");
        if (bpChanged) {
            disable = getOption("disable");
            fixedWidth = getOption("fixedWidth");
            speed = getOption("speed");
            autoHeight = getOption("autoHeight");
            controlsText = getOption("controlsText");
            autoplayText = getOption("autoplayText");
            autoplayTimeout = getOption("autoplayTimeout");
            if (!CSSMQ) {
                edgePadding = getOption("edgePadding");
                gutter = getOption("gutter");
            }
        }
        // update options
        resetVariblesWhenDisable(disable);
        viewport = getViewportWidth(); // <= edgePadding, gutter
        if ((!horizontal || autoWidth) && !disable) {
            setSlidePositions();
            if (!horizontal) {
                updateContentWrapperHeight(); // <= setSlidePositions
                needContainerTransform = true;
            }
        }
        if (fixedWidth || autoWidth) {
            rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
            // fixedWidth: <= viewport, fixedWidth, gutter
            indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
        }
        if (bpChanged || fixedWidth) {
            items = getOption("items");
            slideBy = getOption("slideBy");
            itemsChanged = items !== itemsTem;
            if (itemsChanged) {
                if (!fixedWidth && !autoWidth) indexMax = getIndexMax();
                 // <= items
                // check index before transform in case
                // slider reach the right edge then items become bigger
                updateIndex();
            }
        }
        if (bpChanged) {
            if (disable !== disableTem) {
                if (disable) disableSlider();
                else enableSlider(); // <= slidePositions, rightBoundary, indexMax
            }
        }
        if (freezable && (bpChanged || fixedWidth || autoWidth)) {
            freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
            // <= fixedWidth: fixedWidth, gutter, rightBoundary
            // <= others: items
            if (freeze !== freezeTem) {
                if (freeze) {
                    doContainerTransform(getContainerTransformValue(getStartIndex(0)));
                    freezeSlider();
                } else {
                    unfreezeSlider();
                    needContainerTransform = true;
                }
            }
        }
        resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
        if (!autoplay) autoplayHoverPause = autoplayResetOnVisibility = false;
        if (arrowKeys !== arrowKeysTem) arrowKeys ? (0, $78Ai4.addEvents)(doc, docmentKeydownEvent) : (0, $diLUe.removeEvents)(doc, docmentKeydownEvent);
        if (controls !== controlsTem) {
            if (controls) {
                if (controlsContainer) (0, $lRScj.showElement)(controlsContainer);
                else {
                    if (prevButton) (0, $lRScj.showElement)(prevButton);
                    if (nextButton) (0, $lRScj.showElement)(nextButton);
                }
            } else if (controlsContainer) (0, $1CRAr.hideElement)(controlsContainer);
            else {
                if (prevButton) (0, $1CRAr.hideElement)(prevButton);
                if (nextButton) (0, $1CRAr.hideElement)(nextButton);
            }
        }
        if (nav !== navTem) {
            if (nav) {
                (0, $lRScj.showElement)(navContainer);
                updateNavVisibility();
            } else (0, $1CRAr.hideElement)(navContainer);
        }
        if (touch !== touchTem) touch ? (0, $78Ai4.addEvents)(container, touchEvents, options.preventScrollOnTouch) : (0, $diLUe.removeEvents)(container, touchEvents);
        if (mouseDrag !== mouseDragTem) mouseDrag ? (0, $78Ai4.addEvents)(container, dragEvents) : (0, $diLUe.removeEvents)(container, dragEvents);
        if (autoplay !== autoplayTem) {
            if (autoplay) {
                if (autoplayButton) (0, $lRScj.showElement)(autoplayButton);
                if (!animating && !autoplayUserPaused) startAutoplay();
            } else {
                if (autoplayButton) (0, $1CRAr.hideElement)(autoplayButton);
                if (animating) stopAutoplay();
            }
        }
        if (autoplayHoverPause !== autoplayHoverPauseTem) autoplayHoverPause ? (0, $78Ai4.addEvents)(container, hoverEvents) : (0, $diLUe.removeEvents)(container, hoverEvents);
        if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) autoplayResetOnVisibility ? (0, $78Ai4.addEvents)(doc, visibilityEvent) : (0, $diLUe.removeEvents)(doc, visibilityEvent);
        if (bpChanged) {
            if (fixedWidth !== fixedWidthTem || center !== centerTem) needContainerTransform = true;
            if (autoHeight !== autoHeightTem) {
                if (!autoHeight) innerWrapper.style.height = "";
            }
            if (controls && controlsText !== controlsTextTem) {
                prevButton.innerHTML = controlsText[0];
                nextButton.innerHTML = controlsText[1];
            }
            if (autoplayButton && autoplayText !== autoplayTextTem) {
                var i = autoplay ? 1 : 0, html = autoplayButton.innerHTML, len = html.length - autoplayTextTem[i].length;
                if (html.substring(len) === autoplayTextTem[i]) autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
            }
        } else if (center && (fixedWidth || autoWidth)) needContainerTransform = true;
        if (itemsChanged || fixedWidth && !autoWidth) {
            pages = getPages();
            updateNavVisibility();
        }
        indChanged = index !== indexTem;
        if (indChanged) {
            events.emit("indexChanged", info());
            needContainerTransform = true;
        } else if (itemsChanged) {
            if (!indChanged) additionalUpdates();
        } else if (fixedWidth || autoWidth) {
            doLazyLoad();
            updateSlideStatus();
            updateLiveRegion();
        }
        if (itemsChanged && !carousel) updateGallerySlidePositions();
        if (!disable && !freeze) {
            // non-mediaqueries: IE8
            if (bpChanged && !CSSMQ) {
                // middle wrapper styles
                // inner wrapper styles
                if (edgePadding !== edgePaddingTem || gutter !== gutterTem) innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
                if (horizontal) {
                    // container styles
                    if (carousel) container.style.width = getContainerWidth(fixedWidth, gutter, items);
                    // slide styles
                    var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);
                    // remove the last line and
                    // add new styles
                    (0, $1ZlSw.removeCSSRule)(sheet, (0, $h8JFb.getCssRulesLength)(sheet) - 1);
                    (0, $je0lE.addCSSRule)(sheet, "#" + slideId + " > .tns-item", str, (0, $h8JFb.getCssRulesLength)(sheet));
                }
            }
            // auto height
            if (autoHeight) doAutoHeight();
            if (needContainerTransform) {
                doContainerTransformSilent();
                indexCached = index;
            }
        }
        if (bpChanged) events.emit("newBreakpointEnd", info(e));
    }
    // === INITIALIZATION FUNCTIONS === //
    function getFreeze() {
        if (!fixedWidth && !autoWidth) {
            var a = center ? items - (items - 1) / 2 : items;
            return slideCount <= a;
        }
        var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount], vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;
        if (center) vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
        return width <= vp;
    }
    function setBreakpointZone() {
        breakpointZone = 0;
        for(var bp in responsive){
            bp = parseInt(bp); // convert string to number
            if (windowWidth >= bp) breakpointZone = bp;
        }
    }
    // (slideBy, indexMin, indexMax) => index
    var updateIndex = function() {
        return loop ? carousel ? // loop + carousel
        function() {
            var leftEdge = indexMin, rightEdge = indexMax;
            leftEdge += slideBy;
            rightEdge -= slideBy;
            // adjust edges when has edge paddings
            // or fixed-width slider with extra space on the right side
            if (edgePadding) {
                leftEdge += 1;
                rightEdge -= 1;
            } else if (fixedWidth) {
                if ((viewport + gutter) % (fixedWidth + gutter)) rightEdge -= 1;
            }
            if (cloneCount) {
                if (index > rightEdge) index -= slideCount;
                else if (index < leftEdge) index += slideCount;
            }
        } : // loop + gallery
        function() {
            if (index > indexMax) while(index >= indexMin + slideCount)index -= slideCount;
            else if (index < indexMin) while(index <= indexMax - slideCount)index += slideCount;
        } : // non-loop
        function() {
            index = Math.max(indexMin, Math.min(indexMax, index));
        };
    }();
    function disableUI() {
        if (!autoplay && autoplayButton) (0, $1CRAr.hideElement)(autoplayButton);
        if (!nav && navContainer) (0, $1CRAr.hideElement)(navContainer);
        if (!controls) {
            if (controlsContainer) (0, $1CRAr.hideElement)(controlsContainer);
            else {
                if (prevButton) (0, $1CRAr.hideElement)(prevButton);
                if (nextButton) (0, $1CRAr.hideElement)(nextButton);
            }
        }
    }
    function enableUI() {
        if (autoplay && autoplayButton) (0, $lRScj.showElement)(autoplayButton);
        if (nav && navContainer) (0, $lRScj.showElement)(navContainer);
        if (controls) {
            if (controlsContainer) (0, $lRScj.showElement)(controlsContainer);
            else {
                if (prevButton) (0, $lRScj.showElement)(prevButton);
                if (nextButton) (0, $lRScj.showElement)(nextButton);
            }
        }
    }
    function freezeSlider() {
        if (frozen) return;
        // remove edge padding from inner wrapper
        if (edgePadding) innerWrapper.style.margin = "0px";
        // add class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $fkJZ2.addClass)(slideItems[i], str);
                (0, $fkJZ2.addClass)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        disableUI();
        frozen = true;
    }
    function unfreezeSlider() {
        if (!frozen) return;
        // restore edge padding for inner wrapper
        // for mordern browsers
        if (edgePadding && CSSMQ) innerWrapper.style.margin = "";
        // remove class tns-transparent to cloned slides
        if (cloneCount) {
            var str = "tns-transparent";
            for(var i = cloneCount; i--;){
                if (carousel) (0, $6Hsm5.removeClass)(slideItems[i], str);
                (0, $6Hsm5.removeClass)(slideItems[slideCountNew - i - 1], str);
            }
        }
        // update tools
        enableUI();
        frozen = false;
    }
    function disableSlider() {
        if (disabled) return;
        sheet.disabled = true;
        container.className = container.className.replace(newContainerClasses.substring(1), "");
        (0, $9y8Cf.removeAttrs)(container, [
            "style"
        ]);
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $1CRAr.hideElement)(slideItems[j]);
            (0, $1CRAr.hideElement)(slideItems[slideCountNew - j - 1]);
        }
        // vertical slider
        if (!horizontal || !carousel) (0, $9y8Cf.removeAttrs)(innerWrapper, [
            "style"
        ]);
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i];
            (0, $9y8Cf.removeAttrs)(item, [
                "style"
            ]);
            (0, $6Hsm5.removeClass)(item, animateIn);
            (0, $6Hsm5.removeClass)(item, animateNormal);
        }
        // update tools
        disableUI();
        disabled = true;
    }
    function enableSlider() {
        if (!disabled) return;
        sheet.disabled = false;
        container.className += newContainerClasses;
        doContainerTransformSilent();
        if (loop) for(var j = cloneCount; j--;){
            if (carousel) (0, $lRScj.showElement)(slideItems[j]);
            (0, $lRScj.showElement)(slideItems[slideCountNew - j - 1]);
        }
        // gallery
        if (!carousel) for(var i = index, l = index + slideCount; i < l; i++){
            var item = slideItems[i], classN = i < index + items ? animateIn : animateNormal;
            item.style.left = (i - index) * 100 / items + "%";
            (0, $fkJZ2.addClass)(item, classN);
        }
        // update tools
        enableUI();
        disabled = false;
    }
    function updateLiveRegion() {
        var str = getLiveRegionStr();
        if (liveregionCurrent.innerHTML !== str) liveregionCurrent.innerHTML = str;
    }
    function getLiveRegionStr() {
        var arr = getVisibleSlideRange(), start = arr[0] + 1, end = arr[1] + 1;
        return start === end ? start + "" : start + " to " + end;
    }
    function getVisibleSlideRange(val) {
        if (val == null) val = getContainerTransformValue();
        var start = index, end, rangestart, rangeend;
        // get range start, range end for autoWidth and fixedWidth
        if (center || edgePadding) {
            if (autoWidth || fixedWidth) {
                rangestart = -(parseFloat(val) + edgePadding);
                rangeend = rangestart + viewport + edgePadding * 2;
            }
        } else if (autoWidth) {
            rangestart = slidePositions[index];
            rangeend = rangestart + viewport;
        }
        // get start, end
        // - check auto width
        if (autoWidth) slidePositions.forEach(function(point, i) {
            if (i < slideCountNew) {
                if ((center || edgePadding) && point <= rangestart + 0.5) start = i;
                if (rangeend - point >= 0.5) end = i;
            }
        });
        else {
            if (fixedWidth) {
                var cell = fixedWidth + gutter;
                if (center || edgePadding) {
                    start = Math.floor(rangestart / cell);
                    end = Math.ceil(rangeend / cell - 1);
                } else end = start + Math.ceil(viewport / cell) - 1;
            } else if (center || edgePadding) {
                var a = items - 1;
                if (center) {
                    start -= a / 2;
                    end = index + a / 2;
                } else end = index + a;
                if (edgePadding) {
                    var b = edgePadding * items / viewport;
                    start -= b;
                    end += b;
                }
                start = Math.floor(start);
                end = Math.ceil(end);
            } else end = start + items - 1;
            start = Math.max(start, 0);
            end = Math.min(end, slideCountNew - 1);
        }
        return [
            start,
            end
        ];
    }
    function doLazyLoad() {
        if (lazyload && !disable) {
            var arg = getVisibleSlideRange();
            arg.push(lazyloadSelector);
            getImageArray.apply(null, arg).forEach(function(img) {
                if (!(0, $fH2Ol.hasClass)(img, imgCompleteClass)) {
                    // stop propagation transitionend event to container
                    var eve = {};
                    eve[TRANSITIONEND] = function(e) {
                        e.stopPropagation();
                    };
                    (0, $78Ai4.addEvents)(img, eve);
                    (0, $78Ai4.addEvents)(img, imgEvents);
                    // update src
                    img.src = (0, $eazmc.getAttr)(img, "data-src");
                    // update srcset
                    var srcset = (0, $eazmc.getAttr)(img, "data-srcset");
                    if (srcset) img.srcset = srcset;
                    (0, $fkJZ2.addClass)(img, "loading");
                }
            });
        }
    }
    function onImgLoaded(e) {
        imgLoaded(getTarget(e));
    }
    function onImgFailed(e) {
        imgFailed(getTarget(e));
    }
    function imgLoaded(img) {
        (0, $fkJZ2.addClass)(img, "loaded");
        imgCompleted(img);
    }
    function imgFailed(img) {
        (0, $fkJZ2.addClass)(img, "failed");
        imgCompleted(img);
    }
    function imgCompleted(img) {
        (0, $fkJZ2.addClass)(img, imgCompleteClass);
        (0, $6Hsm5.removeClass)(img, "loading");
        (0, $diLUe.removeEvents)(img, imgEvents);
    }
    function getImageArray(start, end, imgSelector) {
        var imgs = [];
        if (!imgSelector) imgSelector = "img";
        while(start <= end){
            (0, $5Zhog.forEach)(slideItems[start].querySelectorAll(imgSelector), function(img) {
                imgs.push(img);
            });
            start++;
        }
        return imgs;
    }
    // check if all visible images are loaded
    // and update container height if it's done
    function doAutoHeight() {
        var imgs = getImageArray.apply(null, getVisibleSlideRange());
        (0, $4NViB.raf)(function() {
            imgsLoadedCheck(imgs, updateInnerWrapperHeight);
        });
    }
    function imgsLoadedCheck(imgs, cb) {
        // execute callback function if all images are complete
        if (imgsComplete) return cb();
        // check image classes
        imgs.forEach(function(img, index) {
            if (!lazyload && img.complete) imgCompleted(img);
             // Check image.complete
            if ((0, $fH2Ol.hasClass)(img, imgCompleteClass)) imgs.splice(index, 1);
        });
        // execute callback function if selected images are all complete
        if (!imgs.length) return cb();
        // otherwise execute this functiona again
        (0, $4NViB.raf)(function() {
            imgsLoadedCheck(imgs, cb);
        });
    }
    function additionalUpdates() {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
        updateControlsStatus();
        updateNavStatus();
    }
    function update_carousel_transition_duration() {
        if (carousel && autoHeight) middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + "s";
    }
    function getMaxSlideHeight(slideStart, slideRange) {
        var heights = [];
        for(var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++)heights.push(slideItems[i].offsetHeight);
        return Math.max.apply(null, heights);
    }
    // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done
    function updateInnerWrapperHeight() {
        var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount), wp = middleWrapper ? middleWrapper : innerWrapper;
        if (wp.style.height !== maxHeight) wp.style.height = maxHeight + "px";
    }
    // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions
    function setSlidePositions() {
        slidePositions = [
            0
        ];
        var attr = horizontal ? "left" : "top", attr2 = horizontal ? "right" : "bottom", base = slideItems[0].getBoundingClientRect()[attr];
        (0, $5Zhog.forEach)(slideItems, function(item, i) {
            // skip the first slide
            if (i) slidePositions.push(item.getBoundingClientRect()[attr] - base);
            // add the end edge
            if (i === slideCountNew - 1) slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        });
    }
    // update slide
    function updateSlideStatus() {
        var range = getVisibleSlideRange(), start = range[0], end = range[1];
        (0, $5Zhog.forEach)(slideItems, function(item, i) {
            // show slides
            if (i >= start && i <= end) {
                if ((0, $fCuOt.hasAttr)(item, "aria-hidden")) {
                    (0, $9y8Cf.removeAttrs)(item, [
                        "aria-hidden",
                        "tabindex"
                    ]);
                    (0, $fkJZ2.addClass)(item, slideActiveClass);
                }
            } else if (!(0, $fCuOt.hasAttr)(item, "aria-hidden")) {
                (0, $gCLCq.setAttrs)(item, {
                    "aria-hidden": "true",
                    "tabindex": "-1"
                });
                (0, $6Hsm5.removeClass)(item, slideActiveClass);
            }
        });
    }
    // gallery: update slide position
    function updateGallerySlidePositions() {
        var l = index + Math.min(slideCount, items);
        for(var i = slideCountNew; i--;){
            var item = slideItems[i];
            if (i >= index && i < l) {
                // add transitions to visible slides when adjusting their positions
                (0, $fkJZ2.addClass)(item, "tns-moving");
                item.style.left = (i - index) * 100 / items + "%";
                (0, $fkJZ2.addClass)(item, animateIn);
                (0, $6Hsm5.removeClass)(item, animateNormal);
            } else if (item.style.left) {
                item.style.left = "";
                (0, $fkJZ2.addClass)(item, animateNormal);
                (0, $6Hsm5.removeClass)(item, animateIn);
            }
            // remove outlet animation
            (0, $6Hsm5.removeClass)(item, animateOut);
        }
        // removing '.tns-moving'
        setTimeout(function() {
            (0, $5Zhog.forEach)(slideItems, function(el) {
                (0, $6Hsm5.removeClass)(el, "tns-moving");
            });
        }, 300);
    }
    // set tabindex on Nav
    function updateNavStatus() {
        // get current nav
        if (nav) {
            navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
            navClicked = -1;
            if (navCurrentIndex !== navCurrentIndexCached) {
                var navPrev = navItems[navCurrentIndexCached], navCurrent = navItems[navCurrentIndex];
                (0, $gCLCq.setAttrs)(navPrev, {
                    "tabindex": "-1",
                    "aria-label": navStr + (navCurrentIndexCached + 1)
                });
                (0, $6Hsm5.removeClass)(navPrev, navActiveClass);
                (0, $gCLCq.setAttrs)(navCurrent, {
                    "aria-label": navStr + (navCurrentIndex + 1) + navStrCurrent
                });
                (0, $9y8Cf.removeAttrs)(navCurrent, "tabindex");
                (0, $fkJZ2.addClass)(navCurrent, navActiveClass);
                navCurrentIndexCached = navCurrentIndex;
            }
        }
    }
    function getLowerCaseNodeName(el) {
        return el.nodeName.toLowerCase();
    }
    function isButton(el) {
        return getLowerCaseNodeName(el) === "button";
    }
    function isAriaDisabled(el) {
        return el.getAttribute("aria-disabled") === "true";
    }
    function disEnableElement(isButton, el, val) {
        if (isButton) el.disabled = val;
        else el.setAttribute("aria-disabled", val.toString());
    }
    // set 'disabled' to true on controls when reach the edges
    function updateControlsStatus() {
        if (!controls || rewind || loop) return;
        var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton), nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton), disablePrev = index <= indexMin ? true : false, disableNext = !rewind && index >= indexMax ? true : false;
        if (disablePrev && !prevDisabled) disEnableElement(prevIsButton, prevButton, true);
        if (!disablePrev && prevDisabled) disEnableElement(prevIsButton, prevButton, false);
        if (disableNext && !nextDisabled) disEnableElement(nextIsButton, nextButton, true);
        if (!disableNext && nextDisabled) disEnableElement(nextIsButton, nextButton, false);
    }
    // set duration
    function resetDuration(el, str) {
        if (TRANSITIONDURATION) el.style[TRANSITIONDURATION] = str;
    }
    function getSliderWidth() {
        return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }
    function getCenterGap(num) {
        if (num == null) num = index;
        var gap = edgePadding ? gutter : 0;
        return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }
    function getRightBoundary() {
        var gap = edgePadding ? gutter : 0, result = viewport + gap - getSliderWidth();
        if (center && !loop) result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
        if (result > 0) result = 0;
        return result;
    }
    function getContainerTransformValue(num) {
        if (num == null) num = index;
        var val;
        if (horizontal && !autoWidth) {
            if (fixedWidth) {
                val = -(fixedWidth + gutter) * num;
                if (center) val += getCenterGap();
            } else {
                var denominator = TRANSFORM ? slideCountNew : items;
                if (center) num -= getCenterGap();
                val = -num * 100 / denominator;
            }
        } else {
            val = -slidePositions[num];
            if (center && autoWidth) val += getCenterGap();
        }
        if (hasRightDeadZone) val = Math.max(val, rightBoundary);
        val += horizontal && !autoWidth && !fixedWidth ? "%" : "px";
        return val;
    }
    function doContainerTransformSilent(val) {
        resetDuration(container, "0s");
        doContainerTransform(val);
    }
    function doContainerTransform(val) {
        if (val == null) val = getContainerTransformValue();
        container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }
    function animateSlide(number, classOut, classIn, isOut) {
        var l = number + items;
        if (!loop) l = Math.min(l, slideCountNew);
        for(var i = number; i < l; i++){
            var item = slideItems[i];
            // set item positions
            if (!isOut) item.style.left = (i - index) * 100 / items + "%";
            if (animateDelay && TRANSITIONDELAY) item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + "s";
            (0, $6Hsm5.removeClass)(item, classOut);
            (0, $fkJZ2.addClass)(item, classIn);
            if (isOut) slideItemsOut.push(item);
        }
    }
    // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers
    var transformCore = function() {
        return carousel ? function() {
            resetDuration(container, "");
            if (TRANSITIONDURATION || !speed) {
                // for morden browsers with non-zero duration or
                // zero duration for all browsers
                doContainerTransform();
                // run fallback function manually
                // when duration is 0 / container is hidden
                if (!speed || !(0, $dcREA.isVisible)(container)) onTransitionEnd();
            } else // for old browser with non-zero duration
            (0, $jhBP3.jsTransform)(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
            if (!horizontal) updateContentWrapperHeight();
        } : function() {
            slideItemsOut = [];
            var eve = {};
            eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
            (0, $diLUe.removeEvents)(slideItems[indexCached], eve);
            (0, $78Ai4.addEvents)(slideItems[index], eve);
            animateSlide(indexCached, animateIn, animateOut, true);
            animateSlide(index, animateNormal, animateIn);
            // run fallback function manually
            // when transition or animation not supported / duration is 0
            if (!TRANSITIONEND || !ANIMATIONEND || !speed || !(0, $dcREA.isVisible)(container)) onTransitionEnd();
        };
    }();
    function render(e, sliderMoved) {
        if (updateIndexBeforeTransform) updateIndex();
        // render when slider was moved (touch or drag) even though index may not change
        if (index !== indexCached || sliderMoved) {
            // events
            events.emit("indexChanged", info());
            events.emit("transitionStart", info());
            if (autoHeight) doAutoHeight();
            // pause autoplay when click or keydown from user
            if (animating && e && [
                "click",
                "keydown"
            ].indexOf(e.type) >= 0) stopAutoplay();
            running = true;
            transformCore();
        }
    }
    /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */ function strTrans(str) {
        return str.toLowerCase().replace(/-/g, "");
    }
    // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height
    function onTransitionEnd(event) {
        // check running on gallery mode
        // make sure trantionend/animationend events run only once
        if (carousel || running) {
            events.emit("transitionEnd", info(event));
            if (!carousel && slideItemsOut.length > 0) for(var i = 0; i < slideItemsOut.length; i++){
                var item = slideItemsOut[i];
                // set item positions
                item.style.left = "";
                if (ANIMATIONDELAY && TRANSITIONDELAY) {
                    item.style[ANIMATIONDELAY] = "";
                    item.style[TRANSITIONDELAY] = "";
                }
                (0, $6Hsm5.removeClass)(item, animateOut);
                (0, $fkJZ2.addClass)(item, animateNormal);
            }
            /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event'
       *    have to check event first, otherwise event.target will cause an error
       * => or 'gallery' mode:
       *   + event target is slide item
       * => or 'carousel' mode:
       *   + event target is container,
       *   + event.property is the same with transform attribute
       */ if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
                if (!updateIndexBeforeTransform) {
                    var indexTem = index;
                    updateIndex();
                    if (index !== indexTem) {
                        events.emit("indexChanged", info());
                        doContainerTransformSilent();
                    }
                }
                if (nested === "inner") events.emit("innerLoaded", info());
                running = false;
                indexCached = index;
            }
        }
    }
    // # ACTIONS
    function goTo(targetIndex, e) {
        if (freeze) return;
        // prev slideBy
        if (targetIndex === "prev") onControlsClick(e, -1);
        else if (targetIndex === "next") onControlsClick(e, 1);
        else {
            if (running) {
                if (preventActionWhenRunning) return;
                else onTransitionEnd();
            }
            var absIndex = getAbsIndex(), indexGap = 0;
            if (targetIndex === "first") indexGap = -absIndex;
            else if (targetIndex === "last") indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
            else {
                if (typeof targetIndex !== "number") targetIndex = parseInt(targetIndex);
                if (!isNaN(targetIndex)) {
                    // from directly called goTo function
                    if (!e) targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
                    indexGap = targetIndex - absIndex;
                }
            }
            // gallery: make sure new page won't overlap with current page
            if (!carousel && indexGap && Math.abs(indexGap) < items) {
                var factor = indexGap > 0 ? 1 : -1;
                indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
            }
            index += indexGap;
            // make sure index is in range
            if (carousel && loop) {
                if (index < indexMin) index += slideCount;
                if (index > indexMax) index -= slideCount;
            }
            // if index is changed, start rendering
            if (getAbsIndex(index) !== getAbsIndex(indexCached)) render(e);
        }
    }
    // on controls click
    function onControlsClick(e, dir) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        var passEventObject;
        if (!dir) {
            e = getEvent(e);
            var target = getTarget(e);
            while(target !== controlsContainer && [
                prevButton,
                nextButton
            ].indexOf(target) < 0)target = target.parentNode;
            var targetIn = [
                prevButton,
                nextButton
            ].indexOf(target);
            if (targetIn >= 0) {
                passEventObject = true;
                dir = targetIn === 0 ? -1 : 1;
            }
        }
        if (rewind) {
            if (index === indexMin && dir === -1) {
                goTo("last", e);
                return;
            } else if (index === indexMax && dir === 1) {
                goTo("first", e);
                return;
            }
        }
        if (dir) {
            index += slideBy * dir;
            if (autoWidth) index = Math.floor(index);
            // pass e when click control buttons or keydown
            render(passEventObject || e && e.type === "keydown" ? e : null);
        }
    }
    // on nav click
    function onNavClick(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        e = getEvent(e);
        var target = getTarget(e), navIndex;
        // find the clicked nav item
        while(target !== navContainer && !(0, $fCuOt.hasAttr)(target, "data-nav"))target = target.parentNode;
        if ((0, $fCuOt.hasAttr)(target, "data-nav")) {
            var navIndex = navClicked = Number((0, $eazmc.getAttr)(target, "data-nav")), targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items, targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
            goTo(targetIndex, e);
            if (navCurrentIndex === navIndex) {
                if (animating) stopAutoplay();
                navClicked = -1; // reset navClicked
            }
        }
    }
    // autoplay functions
    function setAutoplayTimer() {
        autoplayTimer = setInterval(function() {
            onControlsClick(null, autoplayDirection);
        }, autoplayTimeout);
        animating = true;
    }
    function stopAutoplayTimer() {
        clearInterval(autoplayTimer);
        animating = false;
    }
    function updateAutoplayButton(action, txt) {
        (0, $gCLCq.setAttrs)(autoplayButton, {
            "data-action": action
        });
        autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }
    function startAutoplay() {
        setAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("stop", autoplayText[1]);
    }
    function stopAutoplay() {
        stopAutoplayTimer();
        if (autoplayButton) updateAutoplayButton("start", autoplayText[0]);
    }
    // programaitcally play/pause the slider
    function play() {
        if (autoplay && !animating) {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function pause() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        }
    }
    function toggleAutoplay() {
        if (animating) {
            stopAutoplay();
            autoplayUserPaused = true;
        } else {
            startAutoplay();
            autoplayUserPaused = false;
        }
    }
    function onVisibilityChange() {
        if (doc.hidden) {
            if (animating) {
                stopAutoplayTimer();
                autoplayVisibilityPaused = true;
            }
        } else if (autoplayVisibilityPaused) {
            setAutoplayTimer();
            autoplayVisibilityPaused = false;
        }
    }
    function mouseoverPause() {
        if (animating) {
            stopAutoplayTimer();
            autoplayHoverPaused = true;
        }
    }
    function mouseoutRestart() {
        if (autoplayHoverPaused) {
            setAutoplayTimer();
            autoplayHoverPaused = false;
        }
    }
    // keydown events on document
    function onDocumentKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) onControlsClick(e, keyIndex === 0 ? -1 : 1);
    }
    // on key control
    function onControlsKeydown(e) {
        e = getEvent(e);
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT
        ].indexOf(e.keyCode);
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (!prevButton.disabled) onControlsClick(e, -1);
            } else if (!nextButton.disabled) onControlsClick(e, 1);
        }
    }
    // set focus
    function setFocus(el) {
        el.focus();
    }
    // on key nav
    function onNavKeydown(e) {
        e = getEvent(e);
        var curElement = doc.activeElement;
        if (!(0, $fCuOt.hasAttr)(curElement, "data-nav")) return;
        // var code = e.keyCode,
        var keyIndex = [
            KEYS.LEFT,
            KEYS.RIGHT,
            KEYS.ENTER,
            KEYS.SPACE
        ].indexOf(e.keyCode), navIndex = Number((0, $eazmc.getAttr)(curElement, "data-nav"));
        if (keyIndex >= 0) {
            if (keyIndex === 0) {
                if (navIndex > 0) setFocus(navItems[navIndex - 1]);
            } else if (keyIndex === 1) {
                if (navIndex < pages - 1) setFocus(navItems[navIndex + 1]);
            } else {
                navClicked = navIndex;
                goTo(navIndex, e);
            }
        }
    }
    function getEvent(e) {
        e = e || win.event;
        return isTouchEvent(e) ? e.changedTouches[0] : e;
    }
    function getTarget(e) {
        return e.target || win.event.srcElement;
    }
    function isTouchEvent(e) {
        return e.type.indexOf("touch") >= 0;
    }
    function preventDefaultBehavior(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }
    function getMoveDirectionExpected() {
        return (0, $8Vei7.getTouchDirection)((0, $bFwtC.toDegree)(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
    function onPanStart(e) {
        if (running) {
            if (preventActionWhenRunning) return;
            else onTransitionEnd();
        }
        if (autoplay && animating) stopAutoplayTimer();
        panStart = true;
        if (rafIndex) {
            (0, $9yHtX.caf)(rafIndex);
            rafIndex = null;
        }
        var $ = getEvent(e);
        events.emit(isTouchEvent(e) ? "touchStart" : "dragStart", info(e));
        if (!isTouchEvent(e) && [
            "img",
            "a"
        ].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) preventDefaultBehavior(e);
        lastPosition.x = initPosition.x = $.clientX;
        lastPosition.y = initPosition.y = $.clientY;
        if (carousel) {
            translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ""));
            resetDuration(container, "0s");
        }
    }
    function onPanMove(e) {
        if (panStart) {
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            if (carousel) {
                if (!rafIndex) rafIndex = (0, $4NViB.raf)(function() {
                    panUpdate(e);
                });
            } else {
                if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
                if (moveDirectionExpected) preventScroll = true;
            }
            if ((typeof e.cancelable !== "boolean" || e.cancelable) && preventScroll) e.preventDefault();
        }
    }
    function panUpdate(e) {
        if (!moveDirectionExpected) {
            panStart = false;
            return;
        }
        (0, $9yHtX.caf)(rafIndex);
        if (panStart) rafIndex = (0, $4NViB.raf)(function() {
            panUpdate(e);
        });
        if (moveDirectionExpected === "?") moveDirectionExpected = getMoveDirectionExpected();
        if (moveDirectionExpected) {
            if (!preventScroll && isTouchEvent(e)) preventScroll = true;
            try {
                if (e.type) events.emit(isTouchEvent(e) ? "touchMove" : "dragMove", info(e));
            } catch (err) {}
            var x = translateInit, dist = getDist(lastPosition, initPosition);
            if (!horizontal || fixedWidth || autoWidth) {
                x += dist;
                x += "px";
            } else {
                var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
                x += percentageX;
                x += "%";
            }
            container.style[transformAttr] = transformPrefix + x + transformPostfix;
        }
    }
    function onPanEnd(e) {
        if (panStart) {
            if (rafIndex) {
                (0, $9yHtX.caf)(rafIndex);
                rafIndex = null;
            }
            if (carousel) resetDuration(container, "");
            panStart = false;
            var $ = getEvent(e);
            lastPosition.x = $.clientX;
            lastPosition.y = $.clientY;
            var dist = getDist(lastPosition, initPosition);
            if (Math.abs(dist)) {
                // drag vs click
                if (!isTouchEvent(e)) {
                    // prevent "click"
                    var target = getTarget(e);
                    (0, $78Ai4.addEvents)(target, {
                        "click": function preventClick(e) {
                            preventDefaultBehavior(e);
                            (0, $diLUe.removeEvents)(target, {
                                "click": preventClick
                            });
                        }
                    });
                }
                if (carousel) rafIndex = (0, $4NViB.raf)(function() {
                    if (horizontal && !autoWidth) {
                        var indexMoved = -dist * items / (viewport + gutter);
                        indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                        index += indexMoved;
                    } else {
                        var moved = -(translateInit + dist);
                        if (moved <= 0) index = indexMin;
                        else if (moved >= slidePositions[slideCountNew - 1]) index = indexMax;
                        else {
                            var i = 0;
                            while(i < slideCountNew && moved >= slidePositions[i]){
                                index = i;
                                if (moved > slidePositions[i] && dist < 0) index += 1;
                                i++;
                            }
                        }
                    }
                    render(e, dist);
                    events.emit(isTouchEvent(e) ? "touchEnd" : "dragEnd", info(e));
                });
                else if (moveDirectionExpected) onControlsClick(e, dist > 0 ? -1 : 1);
            }
        }
        // reset
        if (options.preventScrollOnTouch === "auto") preventScroll = false;
        if (swipeAngle) moveDirectionExpected = "?";
        if (autoplay && !animating) setAutoplayTimer();
    }
    // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height
    function updateContentWrapperHeight() {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.style.height = slidePositions[index + items] - slidePositions[index] + "px";
    }
    function getPages() {
        var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
        return Math.min(Math.ceil(rough), slideCount);
    }
    /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */ function updateNavVisibility() {
        if (!nav || navAsThumbnails) return;
        if (pages !== pagesCached) {
            var min = pagesCached, max = pages, fn = (0, $lRScj.showElement);
            if (pagesCached > pages) {
                min = pages;
                max = pagesCached;
                fn = (0, $1CRAr.hideElement);
            }
            while(min < max){
                fn(navItems[min]);
                min++;
            }
            // cache pages
            pagesCached = pages;
        }
    }
    function info(e) {
        return {
            container: container,
            slideItems: slideItems,
            navContainer: navContainer,
            navItems: navItems,
            controlsContainer: controlsContainer,
            hasControls: hasControls,
            prevButton: prevButton,
            nextButton: nextButton,
            items: items,
            slideBy: slideBy,
            cloneCount: cloneCount,
            slideCount: slideCount,
            slideCountNew: slideCountNew,
            index: index,
            indexCached: indexCached,
            displayIndex: getCurrentSlide(),
            navCurrentIndex: navCurrentIndex,
            navCurrentIndexCached: navCurrentIndexCached,
            pages: pages,
            pagesCached: pagesCached,
            sheet: sheet,
            isOn: isOn,
            event: e || {}
        };
    }
    return {
        version: "2.9.3",
        getInfo: info,
        events: events,
        goTo: goTo,
        play: play,
        pause: pause,
        isOn: isOn,
        updateSliderHeight: updateInnerWrapperHeight,
        refresh: initSliderTransform,
        destroy: destroy,
        rebuild: function() {
            return $b83fce493f653d9f$export$51fe319e24d9d8c9((0, $b2MWu.extend)(options, optionsElements));
        }
    };
};

});
parcelRegister("4NViB", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $37f82f716b99ca9d$export$27f233d61a9e2fa4; });
var $37f82f716b99ca9d$var$win = window;
var $37f82f716b99ca9d$export$27f233d61a9e2fa4 = $37f82f716b99ca9d$var$win.requestAnimationFrame || $37f82f716b99ca9d$var$win.webkitRequestAnimationFrame || $37f82f716b99ca9d$var$win.mozRequestAnimationFrame || $37f82f716b99ca9d$var$win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
};

});

parcelRegister("9yHtX", function(module, exports) {

$parcel$export(module.exports, "caf", function () { return $6f5904ab1305bf36$export$75aab3dbee8deceb; });
var $6f5904ab1305bf36$var$win = window;
var $6f5904ab1305bf36$export$75aab3dbee8deceb = $6f5904ab1305bf36$var$win.cancelAnimationFrame || $6f5904ab1305bf36$var$win.mozCancelAnimationFrame || function(id) {
    clearTimeout(id);
};

});

parcelRegister("b2MWu", function(module, exports) {

$parcel$export(module.exports, "extend", function () { return $80a5d888f2ff678b$export$8b58be045bf06082; });
function $80a5d888f2ff678b$export$8b58be045bf06082() {
    var obj, name, copy, target = arguments[0] || {}, i = 1, length = arguments.length;
    for(; i < length; i++){
        if ((obj = arguments[i]) !== null) for(name in obj){
            copy = obj[name];
            if (target === copy) continue;
            else if (copy !== undefined) target[name] = copy;
        }
    }
    return target;
}

});

parcelRegister("gzKiH", function(module, exports) {

$parcel$export(module.exports, "checkStorageValue", function () { return $c113d49399cf2348$export$79d1167a24e4e930; });
function $c113d49399cf2348$export$79d1167a24e4e930(value) {
    return [
        "true",
        "false"
    ].indexOf(value) >= 0 ? JSON.parse(value) : value;
}

});

parcelRegister("LBcQ2", function(module, exports) {

$parcel$export(module.exports, "setLocalStorage", function () { return $08f14040496a5cf1$export$1f73f60bdb811cb1; });
function $08f14040496a5cf1$export$1f73f60bdb811cb1(storage, key, value, access) {
    if (access) try {
        storage.setItem(key, value);
    } catch (e) {}
    return value;
}

});

parcelRegister("PI8R3", function(module, exports) {

$parcel$export(module.exports, "getSlideId", function () { return $09b7012e1fbaac3e$export$ff0ccbbb2d1923f6; });
function $09b7012e1fbaac3e$export$ff0ccbbb2d1923f6() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return "tns" + window.tnsId;
}

});

parcelRegister("6fCzg", function(module, exports) {

$parcel$export(module.exports, "calc", function () { return $48d20f8cacea43ad$export$42bfa9b2d4dad91a; });
// get css-calc 
// @return - false | calc | -webkit-calc | -moz-calc
// @usage - var calc = getCalc(); 

var $ct8iJ = parcelRequire("ct8iJ");

var $g6FsE = parcelRequire("g6FsE");

var $4CXmp = parcelRequire("4CXmp");
function $48d20f8cacea43ad$export$42bfa9b2d4dad91a() {
    var doc = document, body = (0, $ct8iJ.getBody)(), docOverflow = (0, $g6FsE.setFakeBody)(body), div = doc.createElement("div"), result = false;
    body.appendChild(div);
    try {
        var str = "(10px * 10)", vals = [
            "calc" + str,
            "-moz-calc" + str,
            "-webkit-calc" + str
        ], val;
        for(var i = 0; i < 3; i++){
            val = vals[i];
            div.style.width = val;
            if (div.offsetWidth === 100) {
                result = val.replace(str, "");
                break;
            }
        }
    } catch (e) {}
    body.fake ? (0, $4CXmp.resetFakeBody)(body, docOverflow) : div.remove();
    return result;
}

});
parcelRegister("ct8iJ", function(module, exports) {

$parcel$export(module.exports, "getBody", function () { return $913ea1eb8a0d3f14$export$135b49d4bc2964c6; });
function $913ea1eb8a0d3f14$export$135b49d4bc2964c6() {
    var doc = document, body = doc.body;
    if (!body) {
        body = doc.createElement("body");
        body.fake = true;
    }
    return body;
}

});

parcelRegister("g6FsE", function(module, exports) {

$parcel$export(module.exports, "setFakeBody", function () { return $bb9d5e329e200d48$export$4078b67b5eba0c5; });

var $72GrN = parcelRequire("72GrN");
function $bb9d5e329e200d48$export$4078b67b5eba0c5(body) {
    var docOverflow = "";
    if (body.fake) {
        docOverflow = (0, $72GrN.docElement).style.overflow;
        //avoid crashing IE8, if background image is used
        body.style.background = "";
        //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
        body.style.overflow = (0, $72GrN.docElement).style.overflow = "hidden";
        (0, $72GrN.docElement).appendChild(body);
    }
    return docOverflow;
}

});
parcelRegister("72GrN", function(module, exports) {

$parcel$export(module.exports, "docElement", function () { return $5209a576f8d5d553$export$9dfbf2fa8806212d; });
var $5209a576f8d5d553$export$9dfbf2fa8806212d = document.documentElement;

});


parcelRegister("4CXmp", function(module, exports) {

$parcel$export(module.exports, "resetFakeBody", function () { return $35e8c1cd4b43e9fd$export$81b27fa331809b9b; });

var $72GrN = parcelRequire("72GrN");
function $35e8c1cd4b43e9fd$export$81b27fa331809b9b(body, docOverflow) {
    if (body.fake) {
        body.remove();
        (0, $72GrN.docElement).style.overflow = docOverflow;
        // Trigger layout so kinetic scrolling isn't disabled in iOS6+
        // eslint-disable-next-line
        (0, $72GrN.docElement).offsetHeight;
    }
}

});


parcelRegister("9ahPU", function(module, exports) {

$parcel$export(module.exports, "percentageLayout", function () { return $6ac2e21e36aa45b8$export$7b334bfa4e585549; });
// get subpixel support value
// @return - boolean

var $ct8iJ = parcelRequire("ct8iJ");

var $g6FsE = parcelRequire("g6FsE");

var $4CXmp = parcelRequire("4CXmp");
function $6ac2e21e36aa45b8$export$7b334bfa4e585549() {
    // check subpixel layout supporting
    var doc = document, body = (0, $ct8iJ.getBody)(), docOverflow = (0, $g6FsE.setFakeBody)(body), wrapper = doc.createElement("div"), outer = doc.createElement("div"), str = "", count = 70, perPage = 3, supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";
    for(var i = 0; i < count; i++)str += "<div></div>";
    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? (0, $4CXmp.resetFakeBody)(body, docOverflow) : wrapper.remove();
    return supported;
}

});

parcelRegister("jnIJF", function(module, exports) {

$parcel$export(module.exports, "mediaquerySupport", function () { return $e1c2ddd8b6b54b1a$export$48976c233ddfebe2; });

var $ct8iJ = parcelRequire("ct8iJ");

var $g6FsE = parcelRequire("g6FsE");

var $4CXmp = parcelRequire("4CXmp");
function $e1c2ddd8b6b54b1a$export$48976c233ddfebe2() {
    if (window.matchMedia || window.msMatchMedia) return true;
    var doc = document, body = (0, $ct8iJ.getBody)(), docOverflow = (0, $g6FsE.setFakeBody)(body), div = doc.createElement("div"), style = doc.createElement("style"), rule = "@media all and (min-width:1px){.tns-mq-test{position:absolute}}", position;
    style.type = "text/css";
    div.className = "tns-mq-test";
    body.appendChild(style);
    body.appendChild(div);
    if (style.styleSheet) style.styleSheet.cssText = rule;
    else style.appendChild(doc.createTextNode(rule));
    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle["position"];
    body.fake ? (0, $4CXmp.resetFakeBody)(body, docOverflow) : div.remove();
    return position === "absolute";
}

});

parcelRegister("jRsRU", function(module, exports) {

$parcel$export(module.exports, "createStyleSheet", function () { return $e7595c440182cabb$export$d07d6a5154e3b470; });
// create and append style sheet
function $e7595c440182cabb$export$d07d6a5154e3b470(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style");
    // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")
    if (media) style.setAttribute("media", media);
    // Add nonce attribute for Content Security Policy
    if (nonce) style.setAttribute("nonce", nonce);
    // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page
    document.querySelector("head").appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
}

});

parcelRegister("je0lE", function(module, exports) {

$parcel$export(module.exports, "addCSSRule", function () { return $dfef9848b72eb103$export$bf97e331026f75ba; });
// cross browsers addRule method
parcelRequire("4NViB");
function $dfef9848b72eb103$export$bf97e331026f75ba(sheet, selector, rules, index) {
    // return raf(function() {
    "insertRule" in sheet ? sheet.insertRule(selector + "{" + rules + "}", index) : sheet.addRule(selector, rules, index);
// });
}

});

parcelRegister("1ZlSw", function(module, exports) {

$parcel$export(module.exports, "removeCSSRule", function () { return $172c758b793e0399$export$271e480b8a432c4a; });
// cross browsers addRule method
parcelRequire("4NViB");
function $172c758b793e0399$export$271e480b8a432c4a(sheet, index) {
    // return raf(function() {
    "deleteRule" in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
// });
}

});

parcelRegister("h8JFb", function(module, exports) {

$parcel$export(module.exports, "getCssRulesLength", function () { return $c7a69ac95b34cd46$export$ccd7e907f4f59892; });
function $c7a69ac95b34cd46$export$ccd7e907f4f59892(sheet) {
    var rule = "insertRule" in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
}

});

parcelRegister("bFwtC", function(module, exports) {

$parcel$export(module.exports, "toDegree", function () { return $87ecb74121867459$export$c796d9d3e501591f; });
function $87ecb74121867459$export$c796d9d3e501591f(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
}

});

parcelRegister("8Vei7", function(module, exports) {

$parcel$export(module.exports, "getTouchDirection", function () { return $67eebb8b3d2e7afe$export$83b6d73568c72b60; });
function $67eebb8b3d2e7afe$export$83b6d73568c72b60(angle, range) {
    var direction = false, gap = Math.abs(90 - Math.abs(angle));
    if (gap >= 90 - range) direction = "horizontal";
    else if (gap <= range) direction = "vertical";
    return direction;
}

});

parcelRegister("5Zhog", function(module, exports) {

$parcel$export(module.exports, "forEach", function () { return $45c0239a43af3013$export$4b80e395e36b5a56; });
// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function $45c0239a43af3013$export$4b80e395e36b5a56(arr, callback, scope) {
    for(var i = 0, l = arr.length; i < l; i++)callback.call(scope, arr[i], i);
}

});

parcelRegister("fH2Ol", function(module, exports) {

$parcel$export(module.exports, "hasClass", function () { return $b6cd0d618f7f78cf$export$4ea3d958472af68f; });
$parcel$export(module.exports, "classListSupport", function () { return (parcelRequire("jT9DS")).classListSupport; });

var $jT9DS = parcelRequire("jT9DS");
var $b6cd0d618f7f78cf$export$4ea3d958472af68f = (0, $jT9DS.classListSupport) ? function(el, str) {
    return el.classList.contains(str);
} : function(el, str) {
    return el.className.indexOf(str) >= 0;
};

});
parcelRegister("jT9DS", function(module, exports) {

$parcel$export(module.exports, "classListSupport", function () { return $e7aaa21a69194bf7$export$8b753db5fc454027; });
var $e7aaa21a69194bf7$export$8b753db5fc454027 = "classList" in document.createElement("_");

});


parcelRegister("fkJZ2", function(module, exports) {

$parcel$export(module.exports, "addClass", function () { return $b29c649ca1b6259d$export$d2cf6cd1dc7067d3; });
parcelRequire("fH2Ol");
var $jT9DS = parcelRequire("jT9DS");
var $fH2Ol = parcelRequire("fH2Ol");
var $b29c649ca1b6259d$export$d2cf6cd1dc7067d3 = (0, $jT9DS.classListSupport) ? function(el, str) {
    if (!(0, $fH2Ol.hasClass)(el, str)) el.classList.add(str);
} : function(el, str) {
    if (!(0, $fH2Ol.hasClass)(el, str)) el.className += " " + str;
};

});

parcelRegister("6Hsm5", function(module, exports) {

$parcel$export(module.exports, "removeClass", function () { return $4e0cc0f8a3ab59ee$export$c2255604a80b4506; });
parcelRequire("fH2Ol");
var $jT9DS = parcelRequire("jT9DS");
var $fH2Ol = parcelRequire("fH2Ol");
var $4e0cc0f8a3ab59ee$export$c2255604a80b4506 = (0, $jT9DS.classListSupport) ? function(el, str) {
    if ((0, $fH2Ol.hasClass)(el, str)) el.classList.remove(str);
} : function(el, str) {
    if ((0, $fH2Ol.hasClass)(el, str)) el.className = el.className.replace(str, "");
};

});

parcelRegister("fCuOt", function(module, exports) {

$parcel$export(module.exports, "hasAttr", function () { return $b5f24e7ba3b0912f$export$5608640b1bf2f6d7; });
function $b5f24e7ba3b0912f$export$5608640b1bf2f6d7(el, attr) {
    return el.hasAttribute(attr);
}

});

parcelRegister("eazmc", function(module, exports) {

$parcel$export(module.exports, "getAttr", function () { return $a50d6d08af90673c$export$6a93fe6b2b4c71a0; });
function $a50d6d08af90673c$export$6a93fe6b2b4c71a0(el, attr) {
    return el.getAttribute(attr);
}

});

parcelRegister("gCLCq", function(module, exports) {

$parcel$export(module.exports, "setAttrs", function () { return $c1a5220f41f64d80$export$7e45664a2081efb1; });

var $kDRfq = parcelRequire("kDRfq");
function $c1a5220f41f64d80$export$7e45664a2081efb1(els, attrs) {
    els = (0, $kDRfq.isNodeList)(els) || els instanceof Array ? els : [
        els
    ];
    if (Object.prototype.toString.call(attrs) !== "[object Object]") return;
    for(var i = els.length; i--;)for(var key in attrs)els[i].setAttribute(key, attrs[key]);
}

});
parcelRegister("kDRfq", function(module, exports) {

$parcel$export(module.exports, "isNodeList", function () { return $f070c10bb930829c$export$ff45fc08c57bb9d0; });
function $f070c10bb930829c$export$ff45fc08c57bb9d0(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
}

});


parcelRegister("9y8Cf", function(module, exports) {

$parcel$export(module.exports, "removeAttrs", function () { return $6f3df8f770458163$export$711225beb0f1ef57; });

var $kDRfq = parcelRequire("kDRfq");
function $6f3df8f770458163$export$711225beb0f1ef57(els, attrs) {
    els = (0, $kDRfq.isNodeList)(els) || els instanceof Array ? els : [
        els
    ];
    attrs = attrs instanceof Array ? attrs : [
        attrs
    ];
    var attrLength = attrs.length;
    for(var i = els.length; i--;)for(var j = attrLength; j--;)els[i].removeAttribute(attrs[j]);
}

});

parcelRegister("7bhjn", function(module, exports) {

$parcel$export(module.exports, "arrayFromNodeList", function () { return $53a6fd3172479a30$export$19b645cc08e75c7c; });
function $53a6fd3172479a30$export$19b645cc08e75c7c(nl) {
    var arr = [];
    for(var i = 0, l = nl.length; i < l; i++)arr.push(nl[i]);
    return arr;
}

});

parcelRegister("1CRAr", function(module, exports) {

$parcel$export(module.exports, "hideElement", function () { return $12f2e849a0a78921$export$7669482c90f5c50f; });
function $12f2e849a0a78921$export$7669482c90f5c50f(el, forceHide) {
    if (el.style.display !== "none") el.style.display = "none";
}

});

parcelRegister("lRScj", function(module, exports) {

$parcel$export(module.exports, "showElement", function () { return $feb896b49406fdd2$export$998191bfdf710c72; });
function $feb896b49406fdd2$export$998191bfdf710c72(el, forceHide) {
    if (el.style.display === "none") el.style.display = "";
}

});

parcelRegister("dcREA", function(module, exports) {

$parcel$export(module.exports, "isVisible", function () { return $99d603d5cde816c1$export$795910f5f15a9633; });
function $99d603d5cde816c1$export$795910f5f15a9633(el) {
    return window.getComputedStyle(el).display !== "none";
}

});

parcelRegister("fwFwV", function(module, exports) {

$parcel$export(module.exports, "whichProperty", function () { return $b4da0f307eedcd21$export$d7ea39ebd37f24a6; });
function $b4da0f307eedcd21$export$d7ea39ebd37f24a6(props) {
    if (typeof props === "string") {
        var arr = [
            props
        ], Props = props.charAt(0).toUpperCase() + props.substr(1), prefixes = [
            "Webkit",
            "Moz",
            "ms",
            "O"
        ];
        prefixes.forEach(function(prefix) {
            if (prefix !== "ms" || props === "transform") arr.push(prefix + Props);
        });
        props = arr;
    }
    var el = document.createElement("fakeelement"), len = props.length;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (el.style[prop] !== undefined) return prop;
    }
    return false; // explicit for ie9-
}

});

parcelRegister("17sDF", function(module, exports) {

$parcel$export(module.exports, "has3DTransforms", function () { return $0d0ca8fa9529e37d$export$c0585cbcaae92b06; });

var $ct8iJ = parcelRequire("ct8iJ");

var $g6FsE = parcelRequire("g6FsE");

var $4CXmp = parcelRequire("4CXmp");
function $0d0ca8fa9529e37d$export$c0585cbcaae92b06(tf) {
    if (!tf) return false;
    if (!window.getComputedStyle) return false;
    var doc = document, body = (0, $ct8iJ.getBody)(), docOverflow = (0, $g6FsE.setFakeBody)(body), el = doc.createElement("p"), has3d, cssTF = tf.length > 9 ? "-" + tf.slice(0, -9).toLowerCase() + "-" : "";
    cssTF += "transform";
    // Add it to the body to get the computed style
    body.insertBefore(el, null);
    el.style[tf] = "translate3d(1px,1px,1px)";
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? (0, $4CXmp.resetFakeBody)(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}

});

parcelRegister("hude7", function(module, exports) {

$parcel$export(module.exports, "getEndProperty", function () { return $cbaf7f8e247b81a2$export$41e71ffeacbff65e; });
// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function $cbaf7f8e247b81a2$export$41e71ffeacbff65e(propIn, propOut) {
    var endProp = false;
    if (/^Webkit/.test(propIn)) endProp = "webkit" + propOut + "End";
    else if (/^O/.test(propIn)) endProp = "o" + propOut + "End";
    else if (propIn) endProp = propOut.toLowerCase() + "end";
    return endProp;
}

});

parcelRegister("78Ai4", function(module, exports) {

$parcel$export(module.exports, "addEvents", function () { return $53256e4da740c148$export$aadfb65bee660f96; });

var $b2rQa = parcelRequire("b2rQa");
function $53256e4da740c148$export$aadfb65bee660f96(el, obj, preventScrolling) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 && !preventScrolling ? (0, $b2rQa.passiveOption) : false;
        el.addEventListener(prop, obj[prop], option);
    }
}

});
parcelRegister("b2rQa", function(module, exports) {

$parcel$export(module.exports, "passiveOption", function () { return $80957a27672ec6e7$export$555390bf67cc3262; });
// Test via a getter in the options object to see if the passive property is accessed
var $80957a27672ec6e7$var$supportsPassive = false;
try {
    var $80957a27672ec6e7$var$opts = Object.defineProperty({}, "passive", {
        get: function() {
            $80957a27672ec6e7$var$supportsPassive = true;
        }
    });
    window.addEventListener("test", null, $80957a27672ec6e7$var$opts);
} catch (e) {}
var $80957a27672ec6e7$export$555390bf67cc3262 = $80957a27672ec6e7$var$supportsPassive ? {
    passive: true
} : false;

});


parcelRegister("diLUe", function(module, exports) {

$parcel$export(module.exports, "removeEvents", function () { return $9af21df15975419e$export$da5f6eb3bb522cd; });

var $b2rQa = parcelRequire("b2rQa");
function $9af21df15975419e$export$da5f6eb3bb522cd(el, obj) {
    for(var prop in obj){
        var option = [
            "touchstart",
            "touchmove"
        ].indexOf(prop) >= 0 ? (0, $b2rQa.passiveOption) : false;
        el.removeEventListener(prop, obj[prop], option);
    }
}

});

parcelRegister("4YxDd", function(module, exports) {

$parcel$export(module.exports, "Events", function () { return $39f6da8a4129bf93$export$ada873a34909da65; });
function $39f6da8a4129bf93$export$ada873a34909da65() {
    return {
        topics: {},
        on: function(eventName, fn) {
            this.topics[eventName] = this.topics[eventName] || [];
            this.topics[eventName].push(fn);
        },
        off: function(eventName, fn) {
            if (this.topics[eventName]) {
                for(var i = 0; i < this.topics[eventName].length; i++)if (this.topics[eventName][i] === fn) {
                    this.topics[eventName].splice(i, 1);
                    break;
                }
            }
        },
        emit: function(eventName, data) {
            data.type = eventName;
            if (this.topics[eventName]) this.topics[eventName].forEach(function(fn) {
                fn(data, eventName);
            });
        }
    };
}

});

parcelRegister("jhBP3", function(module, exports) {

$parcel$export(module.exports, "jsTransform", function () { return $e09cf196dffd3fbd$export$e2705a83c013f564; });
function $e09cf196dffd3fbd$export$e2705a83c013f564(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10), unit = to.indexOf("%") >= 0 ? "%" : "px", to = to.replace(unit, ""), from = Number(element.style[attr].replace(prefix, "").replace(postfix, "").replace(unit, "")), positionTick = (to - from) / duration * tick, running;
    setTimeout(moveElement, tick);
    function moveElement() {
        duration -= tick;
        from += positionTick;
        element.style[attr] = prefix + from + unit + postfix;
        if (duration > 0) setTimeout(moveElement, tick);
        else callback();
    }
}

});


parcelRegister("j5Ozl", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $de65b5e8da76f3ef$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "tempSensorsRefs", function () { return $de65b5e8da76f3ef$export$473c8458260396c1; });
$parcel$export(module.exports, "sensorsRefs", function () { return $de65b5e8da76f3ef$export$b48f98d23e5ebaa5; });
$parcel$export(module.exports, "waveSensorsRefs", function () { return $de65b5e8da76f3ef$export$133c7617034fdbd5; });
$parcel$export(module.exports, "webcamsRefs", function () { return $de65b5e8da76f3ef$export$c192c3f7457dce24; });
$parcel$export(module.exports, "harborsRefs", function () { return $de65b5e8da76f3ef$export$6f7220b59964f583; });
$parcel$export(module.exports, "advertisersRefs", function () { return $de65b5e8da76f3ef$export$c008d2212536402d; });
$parcel$export(module.exports, "newsRefs", function () { return $de65b5e8da76f3ef$export$fd3c46227d55d14a; });
$parcel$export(module.exports, "loadSensors", function () { return $de65b5e8da76f3ef$export$ab868ecee7b4b90d; });
$parcel$export(module.exports, "loadWebcams", function () { return $de65b5e8da76f3ef$export$53c9c11a0a0dc48d; });
$parcel$export(module.exports, "loadHarbors", function () { return $de65b5e8da76f3ef$export$5be98e10fc5298cf; });
$parcel$export(module.exports, "loadAdvertisers", function () { return $de65b5e8da76f3ef$export$2e5a093bf8447ec4; });
$parcel$export(module.exports, "asides", function () { return $de65b5e8da76f3ef$export$32a72d8d55e994ba; });
$parcel$export(module.exports, "LayersIcons", function () { return $de65b5e8da76f3ef$export$7156fca1fadfe1fa; });
$parcel$export(module.exports, "windColor", function () { return $de65b5e8da76f3ef$export$cf24b07216fcee4f; });
$parcel$export(module.exports, "tempColor", function () { return $de65b5e8da76f3ef$export$ca280d2986ad7750; });
$parcel$export(module.exports, "waveColor", function () { return $de65b5e8da76f3ef$export$c6e197be8926990e; });
$parcel$export(module.exports, "periodColor", function () { return $de65b5e8da76f3ef$export$fac6c0baacf5cf29; });
$parcel$export(module.exports, "rainColor", function () { return $de65b5e8da76f3ef$export$f3fc4e37f68744b1; });
$parcel$export(module.exports, "piafRainColor", function () { return $de65b5e8da76f3ef$export$44db0dae6a2b2b1; });
$parcel$export(module.exports, "windColorsGradient", function () { return $de65b5e8da76f3ef$export$2a412c7215c5a8ec; });
$parcel$export(module.exports, "singleColorGradient", function () { return $de65b5e8da76f3ef$export$cb96861c1fcdb90b; });

var $4cn58 = parcelRequire("4cn58");

var $58K5x = parcelRequire("58K5x");

var $jC6jg = parcelRequire("jC6jg");

var $9m4VK = parcelRequire("9m4VK");

var $1P3Qj = parcelRequire("1P3Qj");

var $5ewvA = parcelRequire("5ewvA");
var $de65b5e8da76f3ef$export$e506a1d27d1eaa20 = {
    backEndUrl: "https://preprod-backend.windmorbihan.com",
    mapKey: "ZkJJ9tNsbzF6IRldrpeM",
    favoritePath: localStorage.getItem("path"),
    newsDisplay: localStorage.getItem("news-22012025"),
    mapCenter: $de65b5e8da76f3ef$var$getMapCenter(),
    mapZoom: $de65b5e8da76f3ef$var$getMapZoom(),
    minZoom: $de65b5e8da76f3ef$var$getMinZoom(),
    mapBounds: [
        [
            48.6,
            -5.8
        ],
        [
            46.4,
            -1.2
        ]
    ],
    forecastsBounds: [
        [
            49,
            -6
        ],
        [
            45.96,
            -1.05
        ]
    ],
    landColor: "#9AF988",
    coastColor: "#154194",
    popup: null,
    latFreq: 7,
    lngFreq: 10,
    windRanges: [
        [
            0,
            5
        ],
        [
            5,
            8
        ],
        [
            8,
            11
        ],
        [
            11,
            14
        ],
        [
            14,
            17
        ],
        [
            17,
            20
        ],
        [
            20,
            23
        ],
        [
            23,
            26
        ],
        [
            26,
            29
        ],
        [
            29,
            33
        ],
        [
            33,
            37
        ],
        [
            37,
            41
        ],
        [
            41,
            46
        ],
        [
            46,
            50
        ],
        [
            50,
            9999
        ]
    ],
    windColors: {
        c1: "#a5f1f8",
        c2: "#49e1f5",
        c3: "#17ddce",
        c4: "#0be678",
        c5: "#86e725",
        c6: "#f0ea00",
        c7: "#ffcc00",
        c8: "#ff9900",
        c9: "#ff6600",
        c10: "#ff0000",
        c11: "#e6005b",
        c12: "#d60093",
        c13: "#a60ec4",
        c14: "#7c2fab",
        c15: "#58166c"
    },
    windLegendRanges: [
        {
            bLabel: "< 2",
            kLabel: "< 7",
            kmLabel: "< 12",
            color: "#69e6f7"
        },
        {
            bLabel: "3",
            kLabel: "7 - 10",
            kmLabel: "12 - 19",
            color: "#15d9cf"
        },
        {
            bLabel: "4",
            kLabel: "11 - 16",
            kmLabel: "20 - 28",
            color: "#0be678"
        },
        {
            bLabel: "5",
            kLabel: "17 - 21",
            kmLabel: "29 - 38",
            color: "#f0ea00"
        },
        {
            bLabel: "6",
            kLabel: "22 - 27",
            kmLabel: "39 - 49",
            color: "#ff9900"
        },
        {
            bLabel: "7",
            kLabel: "28 - 33",
            kmLabel: "50 - 61",
            color: "#ff0000"
        },
        {
            bLabel: "8",
            kLabel: "34 - 40",
            kmLabel: "62 - 74",
            color: "#d60093"
        },
        {
            bLabel: "9",
            kLabel: "41 - 47",
            kmLabel: "75 - 88",
            color: "#a60ec4"
        },
        {
            bLabel: "> 10",
            kLabel: "> 48",
            kmLabel: "> 89",
            color: "#762da3"
        }
    ],
    wavesLegendRanges: [
        {
            label: "Belle",
            height: "< 0,4m",
            color: "#f5f5f5"
        },
        {
            label: "Peu agit\xe9e",
            height: "0,4 \xe0 1m",
            color: "#b3f0f5"
        },
        {
            label: "(Peu agit\xe9e) \xe0 Agit\xe9e",
            height: "1 \xe0 2m",
            color: "#9ef5bf"
        },
        {
            label: "(Agit\xe9e) \xe0 Forte",
            height: "2m \xe0 4m",
            color: "#f5f58f"
        },
        {
            label: "Tr\xe8s forte",
            height: "4 \xe0 6m",
            color: "#f58787"
        },
        {
            label: "Grosse \xe0 \xe9norme",
            height: "> 6m",
            color: "#e18cf5"
        }
    ],
    beaufortRanges: [
        [
            0,
            7
        ],
        [
            7,
            11
        ],
        [
            11,
            17
        ],
        [
            17,
            22
        ],
        [
            22,
            28
        ],
        [
            28,
            34
        ],
        [
            34,
            41
        ],
        [
            41,
            48
        ],
        [
            48,
            999
        ]
    ],
    beaufortColors: {
        c1: "#69e6f7",
        c2: "#15d9cf",
        c3: "#0be678",
        c4: "#f0ea00",
        c5: "#ff9900",
        c6: "#ff0000",
        c7: "#d60093",
        c8: "#a60ec4",
        c9: "#762da3"
    },
    tempRanges: [
        [
            -99,
            0
        ],
        [
            0,
            6
        ],
        [
            6,
            11
        ],
        [
            11,
            16
        ],
        [
            16,
            21
        ],
        [
            21,
            26
        ],
        [
            26,
            31
        ],
        [
            31,
            36
        ],
        [
            36,
            41
        ],
        [
            41,
            46
        ],
        [
            46,
            999
        ]
    ],
    tempColors: {
        c1: "#000099",
        c2: "#0000ff",
        c3: "#0099ff",
        c4: "#5eae80",
        c5: "#aba83e",
        c6: "#ef9c15",
        c7: "#fc3c28",
        c8: "#d01623",
        c9: "#9f3153",
        c10: "#7a2a5f",
        c11: "#60224b"
    },
    waveRanges: [
        [
            0,
            0.4
        ],
        [
            0.4,
            0.6
        ],
        [
            0.6,
            0.8
        ],
        [
            0.8,
            1
        ],
        [
            1,
            1.3
        ],
        [
            1.3,
            1.6
        ],
        [
            1.6,
            2
        ],
        [
            2,
            2.5
        ],
        [
            2.5,
            3
        ],
        [
            3,
            3.5
        ],
        [
            3.5,
            4
        ],
        [
            4,
            5
        ],
        [
            5,
            6
        ],
        [
            6,
            9
        ],
        [
            9,
            99
        ]
    ],
    waveColors: {
        c0: "rgb(255,255,255)",
        c1: "rgb(232,250,252)",
        c2: "rgb(185,250,255)",
        c3: "rgb(130,230,250)",
        c4: "rgb(148,250,214)",
        c5: "rgb(147,251,162)",
        c6: "rgb(124,244,108)",
        c7: "rgb(238,253,123)",
        c8: "rgb(255,255,93)",
        c9: "rgb(255,226,101)",
        c10: "rgb(255,184,113)",
        c11: "rgb(255,140,113)",
        c12: "rgb(255,109,168)",
        c13: "rgb(255,125,255)",
        c14: "rgb(224,87,247)"
    },
    periodRanges: [
        [
            0,
            7
        ],
        [
            7,
            10
        ],
        [
            10,
            13
        ],
        [
            13,
            16
        ],
        [
            16,
            19
        ],
        [
            19,
            99
        ]
    ],
    periodColors: {
        c1: "#ffffff",
        c2: "#edf6fd",
        c3: "#d6ebfa",
        c4: "#bfdff7",
        c5: "#add6f5",
        c6: "#9bcdf3"
    },
    rainRanges: [
        [
            0,
            3
        ],
        [
            3,
            5
        ],
        [
            5,
            7
        ],
        [
            7,
            99
        ]
    ],
    rainColors: {
        c1: "#fafefe",
        c2: "#eef6f8",
        c3: "#e1f0f3",
        c4: "#d8ecf0"
    },
    piafRainRanges: [
        [
            0,
            0.5
        ],
        [
            0.5,
            1
        ],
        [
            1,
            2
        ],
        [
            2,
            3
        ],
        [
            3,
            4
        ],
        [
            4,
            5
        ],
        [
            5,
            6
        ],
        [
            6,
            7
        ],
        [
            7,
            8
        ],
        [
            8,
            10
        ],
        [
            10,
            12
        ],
        [
            12,
            15
        ],
        [
            15,
            20
        ],
        [
            20,
            30
        ],
        [
            30,
            50
        ],
        [
            50,
            999
        ]
    ],
    piafRainColors: {
        c1: "#18bee0",
        c2: "#43a990",
        c3: "#43a990",
        c4: "#6cc263",
        c5: "#f5f564",
        c6: "#f5f564",
        c7: "#f5f564",
        c8: "#f6b912",
        c9: "#f6b912",
        c10: "#f6b912",
        c11: "#f7752f",
        c12: "#f7752f",
        c13: "#f6342f",
        c14: "#e2369d",
        c15: "#b11b75",
        c16: "#873795"
    },
    piafLayerOpacity: 0.75,
    chartColors: {
        ws: {
            moy: "#005500",
            min: "#9eff9e",
            max: "#00d300"
        },
        wd: {
            moy: "#0000ff",
            min: "#b2b2ff",
            max: "#4a4aff"
        },
        t: {
            moy: "#000000",
            dew: "#0000ff",
            see: "#0000ff"
        },
        p: {
            moy: "#000000"
        },
        h: {
            moy: "#000000"
        },
        wv: {
            moy: "#000000"
        },
        sh: {
            moy: "#0000ff",
            max: "#00d3ff"
        },
        sp: {
            moy: "#005500",
            max: "#00d300"
        },
        sd: {
            moy: "#000000"
        }
    }
};
let $de65b5e8da76f3ef$export$97619dc380b744f8 = {};
var $de65b5e8da76f3ef$export$473c8458260396c1 = {};
var $de65b5e8da76f3ef$export$b48f98d23e5ebaa5 = {};
var $de65b5e8da76f3ef$export$133c7617034fdbd5 = {};
var $de65b5e8da76f3ef$export$c192c3f7457dce24 = [];
var $de65b5e8da76f3ef$export$6f7220b59964f583 = [];
var $de65b5e8da76f3ef$export$c008d2212536402d = [];
var $de65b5e8da76f3ef$export$fd3c46227d55d14a = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($1P3Qj)))).sort().map(function(n) {
    return {
        path: n
    };
});
function $de65b5e8da76f3ef$export$ab868ecee7b4b90d(onComplete) {
    (0, $5ewvA.getAsync)($de65b5e8da76f3ef$export$e506a1d27d1eaa20.backEndUrl + "/capteurs/list.json", function(data) {
        $de65b5e8da76f3ef$export$b48f98d23e5ebaa5 = {
            ...data.sensors["WindSensor"] || {}
        };
        $de65b5e8da76f3ef$export$97619dc380b744f8 = data.sensors["WaveSensor"][73091273];
        $de65b5e8da76f3ef$export$133c7617034fdbd5 = {
            ...data.sensors["WaveSensor"] || {}
        };
        $de65b5e8da76f3ef$export$473c8458260396c1 = {
            ...data.sensors["TempSensor"] || {}
        };
        // waterTempSensorsRefs = [tempSensorsRefs[waterTempSensorId]];
        // delete tempSensorsRefs[waterTempSensorId];
        onComplete(data);
    });
}
function $de65b5e8da76f3ef$export$53c9c11a0a0dc48d(onComplete) {
    (0, $5ewvA.getAsync)($de65b5e8da76f3ef$export$e506a1d27d1eaa20.backEndUrl + "/webcams/list.json", function(data) {
        $de65b5e8da76f3ef$export$c192c3f7457dce24 = data.webcams;
        onComplete(data);
    });
}
function $de65b5e8da76f3ef$export$5be98e10fc5298cf(onComplete) {
    (0, $5ewvA.getAsync)($de65b5e8da76f3ef$export$e506a1d27d1eaa20.backEndUrl + "/harbors/list.json", function(data) {
        $de65b5e8da76f3ef$export$6f7220b59964f583 = data.harbors;
        onComplete(data);
    });
}
function $de65b5e8da76f3ef$export$2e5a093bf8447ec4(onComplete) {
    (0, $5ewvA.getAsync)($de65b5e8da76f3ef$export$e506a1d27d1eaa20.backEndUrl + "/annonceurs/list.json", function(data) {
        $de65b5e8da76f3ef$export$c008d2212536402d = data.advertisers;
        onComplete(data);
    });
}
var $de65b5e8da76f3ef$export$32a72d8d55e994ba = {
    73091273: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_cerema"),
                    href: "https://www.cerema.fr/"
                }
            ]
        },
        {
            map: {
                lat: 47.283,
                lng: -3.287
            }
        },
        {
            devent: false
        }
    ],
    73091304: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_aqta"),
                    href: "https://www.auray-quiberon.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : <strong>6,60m au dessus du toit, soit environ 12m au dessus de la mer</strong></li></ul><p><small>Nouveau capteur LCJ mis en service mardi 21/07/2015.</small></p></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "7557")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "7557-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "7557-2")
            ]
        },
        {
            map: {
                lat: 47.567000,
                lng: -3.004
            }
        }
    ],
    10380037: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : 1,50m au dessus de la coupole, soit <strong>22m au dessus de la terre</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "10380037")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10380037-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10380037-2"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10380037-3")
            ]
        },
        {
            map: {
                lat: 47.547800,
                lng: -2.9183
            }
        }
    ],
    10438252: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_aqta"),
                    href: "https://www.auray-quiberon.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : <strong>7m au dessus du toit, soit 17m au dessus de la terre, soit environ 25m au dessus de la mer</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "10438252")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10438252-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10438252-2"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "10438252-3")
            ]
        },
        {
            map: {
                lat: 47.509500,
                lng: -3.1194
            }
        }
    ],
    73091265: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_aqta"),
                    href: "https://www.auray-quiberon.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : 6m au dessus du toit, soit <strong>9m au dessus de la terre</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "73091265")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091265-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091265-2"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091265-3")
            ]
        },
        {
            map: {
                lat: 47.550833,
                lng: -3.134722
            }
        }
    ],
    73091277: [
        {
            markup: "<section class=\"sensor_description\"><h2>Description de l'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : en haut du s\xe9maphore d'Etel, soit <strong>16m au dessus de la terre</strong></li></ul></section>"
        },
        {
            devent: false
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091277-1")
            ]
        },
        {
            map: {
                lat: 47.646112,
                lng: -3.214433
            }
        }
    ],
    73091279: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_ecn"),
                    href: "https://www.ec-nantes.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_aqta"),
                    href: "https://www.auray-quiberon.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur Gill Windmaster pro 3D</li><li>Hauteur : <strong>29m au dessus de la mer</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "73091279")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091279-1")
            ]
        },
        {
            map: {
                lat: 47.457333,
                lng: -3.045767
            }
        }
    ],
    73091286: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_lorient"),
                    href: "https://www.lorient-agglo.bzh/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_sellor"),
                    href: "https://www.sellor.com/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur Gill Windmaster 3D</li><li>Hauteur : <strong>10m au dessus de la terre</strong></li></section>'
        },
        {
            devent: false
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091286-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091286-2")
            ]
        },
        {
            map: {
                lat: 47.699518,
                lng: -3.46097
            }
        }
    ],
    73091264: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_ecn"),
                    href: "https://www.ec-nantes.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur Gill Windmaster pro 3D</li><li>Hauteur : <strong>34m au dessus de la mer</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "73091264")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091264-1"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091264-2"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091264-3"),
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091264-4")
            ]
        },
        {
            map: {
                lat: 47.321217,
                lng: -2.834867
            }
        }
    ],
    73091293: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_arz"),
                    href: "https://www.mairie-iledarz.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_vannes"),
                    href: "https://www.golfedumorbihan-vannesagglomeration.bzh/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : <strong>6m</strong></li></ul></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "73091293")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091293")
            ]
        },
        {
            map: {
                lat: 47.595000,
                lng: -2.81044
            }
        }
    ],
    73091300: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_lorient"),
                    href: "https://www.lorient-agglo.bzh/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_ecn"),
                    href: "https://www.ec-nantes.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur Gill Windmaster 3D</li><li>Hauteur : <strong>10m au dessus de la terre</strong></li></section>'
        },
        {
            devent: false
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091300")
            ]
        },
        {
            map: {
                lat: 47.647736,
                lng: -3.509733
            }
        }
    ],
    73091302: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_ports_loire_atlantique"),
                    href: "https://lesportsdeloireatlantique.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_loire_atlantique_nautisme"),
                    href: "https://www.loire-atlantique-nautisme.fr/"
                },
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_dirm"),
                    href: "http://www.dirm.nord-atlantique-manche-ouest.developpement-durable.gouv.fr/"
                }
            ]
        },
        {
            markup: '<section class="sensor_description"><h2>Description de l\'installation</h2><ul><li>Capteur LCJ CV7</li><li>Hauteur : <strong>10m au dessus de la terre</strong></li></section>'
        },
        {
            devent: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($58K5x))), "73091302")
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "73091302")
            ]
        },
        {
            map: {
                lat: 47.411505,
                lng: -2.620043
            }
        }
    ],
    7557: [
        {
            links: [
                {
                    img: $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($4cn58))), "logo_crc"),
                    href: "http://www.huitres-de-bretagne.com/"
                }
            ]
        },
        {
            map: {
                lat: 47.55183,
                lng: -3.089282
            }
        },
        {
            devent: false
        },
        {
            slides: [
                $de65b5e8da76f3ef$var$assetPath((0, (/*@__PURE__*/$parcel$interopDefault($jC6jg))), "7557-3")
            ]
        }
    ]
};
const $de65b5e8da76f3ef$export$7156fca1fadfe1fa = (0, (/*@__PURE__*/$parcel$interopDefault($9m4VK)));
function $de65b5e8da76f3ef$var$getValueRange(ranges, value) {
    var i;
    for(i = 0; i < ranges.length; i++){
        if (value >= ranges[i][0] && value < ranges[i][1]) return i;
    }
    return 0;
}
function $de65b5e8da76f3ef$var$getMapCenter() {
    const hostName = window.location.hostname === "localhost" ? window.location.search : window.location.hostname;
    const isMobile = window.innerWidth <= 768;
    let mapCenter = [
        47.509500,
        -3.1194
    ];
    if (hostName.indexOf("windloireatlantique") !== -1) mapCenter = isMobile ? [
        47.2,
        -2.3
    ] : [
        47.2,
        -2.55
    ];
    else if (hostName.indexOf("windcornouaille") !== -1) mapCenter = isMobile ? [
        47.9,
        -4.1
    ] : [
        47.9,
        -4.05
    ];
    return mapCenter;
}
function $de65b5e8da76f3ef$var$getMapZoom() {
    const hostName = window.location.hostname === "localhost" ? window.location.search : window.location.hostname;
    const isMobile = window.innerWidth <= 768;
    let mapZoom = 9.6;
    if (hostName.indexOf("windloireatlantique") !== -1) mapZoom = isMobile ? 9 : 9.5;
    else if (hostName.indexOf("windcornouaille") !== -1) mapZoom = isMobile ? 8.5 : 9.6;
    return mapZoom;
}
function $de65b5e8da76f3ef$var$getMinZoom() {
    const screenRatio = window.innerWidth / window.innerHeight;
    console.debug("screenRatio: " + screenRatio.toString());
    if (screenRatio < 0.75) return 8;
    else if (screenRatio < 1.6) return 8.5;
    else if (screenRatio < 2) return 9;
    else return 8.8;
}
function $de65b5e8da76f3ef$export$cf24b07216fcee4f(windSpeed) {
    var windColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windColors), speedRange = $de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windRanges, windSpeed);
    return {
        bg: windColors[speedRange],
        text: speedRange > 8 ? "#FFFFFF" : "#154194"
    };
}
function $de65b5e8da76f3ef$export$ca280d2986ad7750(temp) {
    var tempColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.tempColors);
    return tempColors[$de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.tempRanges, temp)];
}
function $de65b5e8da76f3ef$export$c6e197be8926990e(waveHeight) {
    var waveColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.waveColors);
    return waveColors[$de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.waveRanges, waveHeight)];
}
function $de65b5e8da76f3ef$export$fac6c0baacf5cf29(period) {
    var periodColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.periodColors);
    return periodColors[$de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.periodRanges, period)];
}
function $de65b5e8da76f3ef$export$f3fc4e37f68744b1(rainHeight) {
    var rainColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.rainColors);
    return rainColors[$de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.rainRanges, rainHeight)];
}
function $de65b5e8da76f3ef$export$44db0dae6a2b2b1(rainHeight) {
    const colorsValues = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.piafRainColors);
    return colorsValues[$de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.piafRainRanges, rainHeight)];
}
function $de65b5e8da76f3ef$var$assetPath(assets, key) {
    return assets[key] ? Object.values(assets[key])[0] : "";
}
function $de65b5e8da76f3ef$export$2a412c7215c5a8ec(windData) {
    let minSpeed = windData.s_min, maxSpeed = windData.s_max, speedRange = maxSpeed - minSpeed;
    let minRange = $de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windRanges, minSpeed), maxRange = $de65b5e8da76f3ef$var$getValueRange($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windRanges, maxSpeed);
    let windColors = Object.values($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windColors), colorStops = [], r;
    for(r = minRange; r <= maxRange; r++){
        let stop = Math.round(($de65b5e8da76f3ef$export$e506a1d27d1eaa20.windRanges[r][0] - $de65b5e8da76f3ef$export$e506a1d27d1eaa20.windRanges[minRange][0]) * 10) / (speedRange * 10);
        if (stop > 1) stop = 1;
        colorStops.push({
            stop: r === minRange ? 0 : stop,
            color: windColors[r]
        });
    }
    console.debug("windColorsGradient : " + JSON.stringify(colorStops));
    return colorStops;
}
function $de65b5e8da76f3ef$export$cb96861c1fcdb90b(color) {
    return [
        {
            stop: 0,
            color: color
        },
        {
            stop: 1,
            color: color
        }
    ];
}

});
parcelRegister("4cn58", function(module, exports) {

var $6jeFv = parcelRequire("6jeFv");

var $lkRTJ = parcelRequire("lkRTJ");

var $6GUPi = parcelRequire("6GUPi");

var $4Cd5B = parcelRequire("4Cd5B");

var $gT9en = parcelRequire("gT9en");

var $64cTD = parcelRequire("64cTD");

var $acS5o = parcelRequire("acS5o");

var $1Vlaq = parcelRequire("1Vlaq");

var $kl91w = parcelRequire("kl91w");

var $d3WBz = parcelRequire("d3WBz");

var $iX4J1 = parcelRequire("iX4J1");

var $1ICRO = parcelRequire("1ICRO");

var $79baj = parcelRequire("79baj");

var $fb2T1 = parcelRequire("fb2T1");

var $13vmM = parcelRequire("13vmM");

var $9uBru = parcelRequire("9uBru");

var $1AFUc = parcelRequire("1AFUc");

var $cSmkK = parcelRequire("cSmkK");

var $iCZuz = parcelRequire("iCZuz");

var $haObl = parcelRequire("haObl");

var $j60H2 = parcelRequire("j60H2");

var $ddDFK = parcelRequire("ddDFK");

var $a1Iat = parcelRequire("a1Iat");

var $k10VQ = parcelRequire("k10VQ");
module.exports = {
    "logo-open-c": {
        "jpg": $6jeFv
    },
    "logo-se-mer-biodiversite": {
        "jpg": $lkRTJ
    },
    "logo": {
        "png": $6GUPi
    },
    "logo_aqta": {
        "png": $4Cd5B
    },
    "logo_arz": {
        "jpg": $gT9en
    },
    "logo_ccpbs": {
        "jpg": $64cTD
    },
    "logo_cerema": {
        "jpg": $acS5o
    },
    "logo_cpm": {
        "png": $1Vlaq
    },
    "logo_crc": {
        "jpg": $kl91w
    },
    "logo_dirm": {
        "jpg": $d3WBz,
        "svg": $iX4J1
    },
    "logo_ecn": {
        "svg": $1ICRO
    },
    "logo_envsn": {
        "svg": $79baj
    },
    "logo_loire_atlantique_nautisme": {
        "png": $fb2T1
    },
    "logo_lorient": {
        "png": $13vmM
    },
    "logo_milieu_marin": {
        "png": $9uBru
    },
    "logo_ofb_h": {
        "jpg": $1AFUc
    },
    "logo_ports_loire_atlantique": {
        "png": $cSmkK
    },
    "logo_qcd": {
        "png": $iCZuz
    },
    "logo_region_bretagne": {
        "png": $haObl
    },
    "logo_sellor": {
        "svg": $j60H2
    },
    "logo_vannes": {
        "jpg": $ddDFK
    },
    "logo_wc": {
        "png": $a1Iat
    },
    "logo_wla": {
        "png": $k10VQ
    }
};

});
parcelRegister("6jeFv", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo-open-c.b922d93a.jpg";

});
parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});


parcelRegister("lkRTJ", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo-se-mer-biodiversite.0111a8a2.jpg";

});

parcelRegister("6GUPi", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo.8fd2eb76.png";

});

parcelRegister("4Cd5B", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_aqta.e902dd37.png";

});

parcelRegister("gT9en", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_arz.3b0e377d.jpg";

});

parcelRegister("64cTD", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_ccpbs.9e0493d0.jpg";

});

parcelRegister("acS5o", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_cerema.edb3eafb.jpg";

});

parcelRegister("1Vlaq", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_cpm.405128db.png";

});

parcelRegister("kl91w", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_crc.eeb919ba.jpg";

});

parcelRegister("d3WBz", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_dirm.b6c964ef.jpg";

});

parcelRegister("iX4J1", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_dirm.cc09e0db.svg";

});

parcelRegister("1ICRO", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_ecn.bd8d5aca.svg";

});

parcelRegister("79baj", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_envsn.673d6776.svg";

});

parcelRegister("fb2T1", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_loire_atlantique_nautisme.293f7d1e.png";

});

parcelRegister("13vmM", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_lorient.c03b280b.png";

});

parcelRegister("9uBru", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_milieu_marin.4fba1df3.png";

});

parcelRegister("1AFUc", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_ofb_h.bebd5f2c.jpg";

});

parcelRegister("cSmkK", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_ports_loire_atlantique.7fde878d.png";

});

parcelRegister("iCZuz", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_qcd.7ac90334.png";

});

parcelRegister("haObl", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_region_bretagne.caddeb8e.png";

});

parcelRegister("j60H2", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_sellor.d402d7de.svg";

});

parcelRegister("ddDFK", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_vannes.6a3c969f.jpg";

});

parcelRegister("a1Iat", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_wc.95babd66.png";

});

parcelRegister("k10VQ", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "logo_wla.5c05c7c3.png";

});


parcelRegister("58K5x", function(module, exports) {

var $4hk68 = parcelRequire("4hk68");

var $7LT91 = parcelRequire("7LT91");

var $27Gge = parcelRequire("27Gge");

var $15yxN = parcelRequire("15yxN");

var $eAJYF = parcelRequire("eAJYF");

var $hU90X = parcelRequire("hU90X");

var $4LCns = parcelRequire("4LCns");

var $fdJcH = parcelRequire("fdJcH");

var $fitmG = parcelRequire("fitmG");
module.exports = {
    "7557": {
        "png": $4hk68
    },
    "10380037": {
        "png": $7LT91
    },
    "10438252": {
        "png": $27Gge
    },
    "73091264": {
        "png": $15yxN
    },
    "73091265": {
        "png": $eAJYF
    },
    "73091279": {
        "png": $hU90X
    },
    "73091293": {
        "png": $4LCns
    },
    "73091300": {
        "png": $fdJcH
    },
    "73091302": {
        "png": $fitmG
    }
};

});
parcelRegister("4hk68", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "7557.3c8b271b.png";

});

parcelRegister("7LT91", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10380037.f6a2d154.png";

});

parcelRegister("27Gge", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10438252.e33ec7d0.png";

});

parcelRegister("15yxN", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091264.3df2361d.png";

});

parcelRegister("eAJYF", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091265.18be801a.png";

});

parcelRegister("hU90X", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091279.3df2361d.png";

});

parcelRegister("4LCns", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091293.77ee0ebd.png";

});

parcelRegister("fdJcH", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091300.77ee0ebd.png";

});

parcelRegister("fitmG", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091302.77ee0ebd.png";

});


parcelRegister("jC6jg", function(module, exports) {

var $8rmcA = parcelRequire("8rmcA");

var $2CRyZ = parcelRequire("2CRyZ");

var $dGJYz = parcelRequire("dGJYz");

var $3GHGd = parcelRequire("3GHGd");

var $eh62G = parcelRequire("eh62G");

var $23zCE = parcelRequire("23zCE");

var $nsbcP = parcelRequire("nsbcP");

var $jBJuE = parcelRequire("jBJuE");

var $9nxST = parcelRequire("9nxST");

var $18gwh = parcelRequire("18gwh");

var $fesHE = parcelRequire("fesHE");

var $gS6Ak = parcelRequire("gS6Ak");

var $bGUDT = parcelRequire("bGUDT");

var $39KYg = parcelRequire("39KYg");

var $6Zf2W = parcelRequire("6Zf2W");

var $khVLI = parcelRequire("khVLI");

var $ibJ5R = parcelRequire("ibJ5R");

var $dz2Eq = parcelRequire("dz2Eq");

var $WU61r = parcelRequire("WU61r");

var $1SGJG = parcelRequire("1SGJG");

var $krNHK = parcelRequire("krNHK");

var $3vnUL = parcelRequire("3vnUL");

var $cBYt9 = parcelRequire("cBYt9");
module.exports = {
    "73091293": {
        "png": $8rmcA
    },
    "73091300": {
        "jpg": $2CRyZ
    },
    "73091302": {
        "jpeg": $dGJYz
    },
    "10380037-1": {
        "png": $3GHGd
    },
    "10380037-2": {
        "png": $eh62G
    },
    "10380037-3": {
        "png": $23zCE
    },
    "10438252-1": {
        "png": $nsbcP
    },
    "10438252-2": {
        "png": $jBJuE
    },
    "10438252-3": {
        "png": $9nxST
    },
    "73091264-1": {
        "png": $18gwh
    },
    "73091264-2": {
        "png": $fesHE
    },
    "73091264-3": {
        "png": $gS6Ak
    },
    "73091264-4": {
        "png": $bGUDT
    },
    "73091265-1": {
        "png": $39KYg
    },
    "73091265-2": {
        "png": $6Zf2W
    },
    "73091265-3": {
        "png": $khVLI
    },
    "73091277-1": {
        "png": $ibJ5R
    },
    "73091279-1": {
        "png": $dz2Eq
    },
    "73091286-1": {
        "png": $WU61r
    },
    "73091286-2": {
        "png": $1SGJG
    },
    "7557-1": {
        "png": $krNHK
    },
    "7557-2": {
        "png": $3vnUL
    },
    "7557-3": {
        "png": $cBYt9
    }
};

});
parcelRegister("8rmcA", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091293.b8079e1e.png";

});

parcelRegister("2CRyZ", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091300.fdac9bc1.jpg";

});

parcelRegister("dGJYz", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091302.2e101f4a.jpeg";

});

parcelRegister("3GHGd", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10380037-1.807f7bab.png";

});

parcelRegister("eh62G", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10380037-2.bf51e171.png";

});

parcelRegister("23zCE", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10380037-3.b3a35e5c.png";

});

parcelRegister("nsbcP", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10438252-1.5073f1af.png";

});

parcelRegister("jBJuE", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10438252-2.87b1cd7f.png";

});

parcelRegister("9nxST", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "10438252-3.b0f53136.png";

});

parcelRegister("18gwh", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091264-1.cc309a38.png";

});

parcelRegister("fesHE", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091264-2.9e12101e.png";

});

parcelRegister("gS6Ak", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091264-3.2f7e6bf0.png";

});

parcelRegister("bGUDT", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091264-4.b3a35e5c.png";

});

parcelRegister("39KYg", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091265-1.6d190cfe.png";

});

parcelRegister("6Zf2W", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091265-2.fc771b59.png";

});

parcelRegister("khVLI", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091265-3.6b73697f.png";

});

parcelRegister("ibJ5R", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091277-1.c533d2ac.png";

});

parcelRegister("dz2Eq", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091279-1.802fad7a.png";

});

parcelRegister("WU61r", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091286-1.9668e4de.png";

});

parcelRegister("1SGJG", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "73091286-2.855f40a9.png";

});

parcelRegister("krNHK", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "7557-1.7d401f9d.png";

});

parcelRegister("3vnUL", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "7557-2.ac6b246f.png";

});

parcelRegister("cBYt9", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "7557-3.74e36fa4.png";

});


parcelRegister("9m4VK", function(module, exports) {

var $kEeHf = parcelRequire("kEeHf");

var $ke7GF = parcelRequire("ke7GF");

var $jsBNM = parcelRequire("jsBNM");

var $2QdXb = parcelRequire("2QdXb");

var $ltVMu = parcelRequire("ltVMu");

var $eziI3 = parcelRequire("eziI3");

var $dbczt = parcelRequire("dbczt");

var $4NSzM = parcelRequire("4NSzM");

var $51lxr = parcelRequire("51lxr");

var $4t5Zk = parcelRequire("4t5Zk");

var $6HWOi = parcelRequire("6HWOi");

var $6CRO0 = parcelRequire("6CRO0");

var $jlDfv = parcelRequire("jlDfv");

var $bDdhR = parcelRequire("bDdhR");

var $6XhO1 = parcelRequire("6XhO1");

var $fFhOA = parcelRequire("fFhOA");

var $b18He = parcelRequire("b18He");

var $ispUk = parcelRequire("ispUk");

var $5wvPZ = parcelRequire("5wvPZ");

var $eW2ky = parcelRequire("eW2ky");

var $7mvCq = parcelRequire("7mvCq");

var $2jwK0 = parcelRequire("2jwK0");

var $7UCZ6 = parcelRequire("7UCZ6");
module.exports = {
    "air-temp": $kEeHf,
    "amp": $ke7GF,
    "elevation-map": $jsBNM,
    "graph-cursor": $2QdXb,
    "layers-2x": $ltVMu,
    "layers": $eziI3,
    "marker-icon-2x": $dbczt,
    "marker-icon": $4NSzM,
    "marker-shadow": $51lxr,
    "rain-fc": $4t5Zk,
    "satellite-map": $6HWOi,
    "species": $6CRO0,
    "spot": $jlDfv,
    "tide-fc": $bDdhR,
    "water-temp": $6XhO1,
    "wave-rt": $fFhOA,
    "waves-fc": $b18He,
    "waves-rt": $ispUk,
    "weather-fc": $5wvPZ,
    "webcams": $eW2ky,
    "wind-fc": $7mvCq,
    "wind-rt": $2jwK0,
    "wm-map": $7UCZ6
};

});
parcelRegister("kEeHf", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "air-temp.c1678179.png";

});

parcelRegister("ke7GF", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "amp.316cbe72.png";

});

parcelRegister("jsBNM", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "elevation-map.9e064d3e.png";

});

parcelRegister("2QdXb", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "graph-cursor.8e1414e0.png";

});

parcelRegister("ltVMu", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "layers-2x.b7b89169.png";

});

parcelRegister("eziI3", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "layers.760a0456.png";

});

parcelRegister("dbczt", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "marker-icon-2x.160d643f.png";

});

parcelRegister("4NSzM", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "marker-icon.3f7d3721.png";

});

parcelRegister("51lxr", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "marker-shadow.8f26ed1f.png";

});

parcelRegister("4t5Zk", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "rain-fc.3dd9a665.png";

});

parcelRegister("6HWOi", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "satellite-map.aeff24db.png";

});

parcelRegister("6CRO0", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "species.e324a04b.png";

});

parcelRegister("jlDfv", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "spot.36db4a1b.png";

});

parcelRegister("bDdhR", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "tide-fc.9e473584.png";

});

parcelRegister("6XhO1", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "water-temp.2d74f9b3.png";

});

parcelRegister("fFhOA", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "wave-rt.60fadf00.png";

});

parcelRegister("b18He", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "waves-fc.64222fba.png";

});

parcelRegister("ispUk", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "waves-rt.8b8ca7d5.png";

});

parcelRegister("5wvPZ", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "weather-fc.f492782d.png";

});

parcelRegister("eW2ky", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "webcams.22473649.png";

});

parcelRegister("7mvCq", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "wind-fc.c707460a.png";

});

parcelRegister("2jwK0", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "wind-rt.73f52874.png";

});

parcelRegister("7UCZ6", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "wm-map.a9955713.png";

});


parcelRegister("1P3Qj", function(module, exports) {

var $1iYNI = parcelRequire("1iYNI");

var $aNB9l = parcelRequire("aNB9l");

var $ioKey = parcelRequire("ioKey");

var $jb5Al = parcelRequire("jb5Al");

var $fwjxz = parcelRequire("fwjxz");

var $aly42 = parcelRequire("aly42");

var $6dAlT = parcelRequire("6dAlT");

var $iiDrU = parcelRequire("iiDrU");

var $9qOEM = parcelRequire("9qOEM");
module.exports = {
    "news01": $1iYNI,
    "news02": $aNB9l,
    "news03": $ioKey,
    "news04": $jb5Al,
    "news05": $fwjxz,
    "news06": $aly42,
    "news07": $6dAlT,
    "news08": $iiDrU,
    "news09": $9qOEM
};

});
parcelRegister("1iYNI", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news01.402c0439.jpg";

});

parcelRegister("aNB9l", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news02.42707f0a.jpg";

});

parcelRegister("ioKey", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news03.2c80d184.jpg";

});

parcelRegister("jb5Al", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news04.c544e39a.jpg";

});

parcelRegister("fwjxz", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news05.3a1ac88e.jpg";

});

parcelRegister("aly42", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news06.a3e3fc7d.jpg";

});

parcelRegister("6dAlT", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news07.ece1af85.jpg";

});

parcelRegister("iiDrU", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news08.2c3c08c2.jpg";

});

parcelRegister("9qOEM", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("5oJ5M") + "news09.bebe69a9.jpg";

});


parcelRegister("5ewvA", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $3cf77a0b1b294975$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "getAsync", function () { return $3cf77a0b1b294975$export$3c52c308b7dea18c; });
$parcel$export(module.exports, "postAsync", function () { return $3cf77a0b1b294975$export$ae6a50d7af679e07; });
function $3cf77a0b1b294975$export$61fc7d43ac8f84b0(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
}
function $3cf77a0b1b294975$export$a1c066623ac679d3(context) {
    context.globalCompositeOperation = "source-over";
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.beginPath();
}
function $3cf77a0b1b294975$export$3c52c308b7dea18c(url, callback, isHtml = false) {
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.onload = function() {
        try {
            callback(isHtml ? ajax.responseText : JSON.parse(ajax.responseText));
        } catch (e) {
            console.error("invalid response");
            console.error(e);
        }
    };
    ajax.send();
}
function $3cf77a0b1b294975$export$ae6a50d7af679e07(url, content, callback) {
    var ajax = new XMLHttpRequest();
    ajax.open("POST", url, true);
    ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    ajax.onload = function() {
        callback(ajax.responseText);
    };
    ajax.send(content);
}

});


parcelRegister("dnPBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9be573a656cafbe3$export$2e2bcd8739ae039; });
function $9be573a656cafbe3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9be573a656cafbe3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9be573a656cafbe3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9be573a656cafbe3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9be573a656cafbe3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9be573a656cafbe3$var$_toConsumableArray(arr) {
    return $9be573a656cafbe3$var$_arrayWithoutHoles(arr) || $9be573a656cafbe3$var$_iterableToArray(arr) || $9be573a656cafbe3$var$_unsupportedIterableToArray(arr) || $9be573a656cafbe3$var$_nonIterableSpread();
}
function $9be573a656cafbe3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9be573a656cafbe3$var$_arrayLikeToArray(arr);
}
function $9be573a656cafbe3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $9be573a656cafbe3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9be573a656cafbe3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9be573a656cafbe3$var$_arrayLikeToArray(o, minLen);
}
function $9be573a656cafbe3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9be573a656cafbe3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $9be573a656cafbe3$var$MicroModal = function() {
    var FOCUSABLE_ELEMENTS = [
        "a[href]",
        "area[href]",
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        "select:not([disabled]):not([aria-hidden])",
        "textarea:not([disabled]):not([aria-hidden])",
        "button:not([disabled]):not([aria-hidden])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        '[tabindex]:not([tabindex^="-"])'
    ];
    var Modal = /*#__PURE__*/ function() {
        function Modal(_ref) {
            var targetModal = _ref.targetModal, _ref$triggers = _ref.triggers, triggers = _ref$triggers === void 0 ? [] : _ref$triggers, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? function() {} : _ref$onShow, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? function() {} : _ref$onClose, _ref$openTrigger = _ref.openTrigger, openTrigger = _ref$openTrigger === void 0 ? "data-micromodal-trigger" : _ref$openTrigger, _ref$closeTrigger = _ref.closeTrigger, closeTrigger = _ref$closeTrigger === void 0 ? "data-micromodal-close" : _ref$closeTrigger, _ref$openClass = _ref.openClass, openClass = _ref$openClass === void 0 ? "is-open" : _ref$openClass, _ref$disableScroll = _ref.disableScroll, disableScroll = _ref$disableScroll === void 0 ? false : _ref$disableScroll, _ref$disableFocus = _ref.disableFocus, disableFocus = _ref$disableFocus === void 0 ? false : _ref$disableFocus, _ref$awaitCloseAnimat = _ref.awaitCloseAnimation, awaitCloseAnimation = _ref$awaitCloseAnimat === void 0 ? false : _ref$awaitCloseAnimat, _ref$awaitOpenAnimati = _ref.awaitOpenAnimation, awaitOpenAnimation = _ref$awaitOpenAnimati === void 0 ? false : _ref$awaitOpenAnimati, _ref$debugMode = _ref.debugMode, debugMode = _ref$debugMode === void 0 ? false : _ref$debugMode;
            $9be573a656cafbe3$var$_classCallCheck(this, Modal);
            // Save a reference of the modal
            this.modal = document.getElementById(targetModal); // Save a reference to the passed config
            this.config = {
                debugMode: debugMode,
                disableScroll: disableScroll,
                openTrigger: openTrigger,
                closeTrigger: closeTrigger,
                openClass: openClass,
                onShow: onShow,
                onClose: onClose,
                awaitCloseAnimation: awaitCloseAnimation,
                awaitOpenAnimation: awaitOpenAnimation,
                disableFocus: disableFocus
            }; // Register click events only if pre binding eventListeners
            if (triggers.length > 0) this.registerTriggers.apply(this, $9be573a656cafbe3$var$_toConsumableArray(triggers)); // pre bind functions for event listeners
            this.onClick = this.onClick.bind(this);
            this.onKeydown = this.onKeydown.bind(this);
        }
        /**
     * Loops through all openTriggers and binds click event
     * @param  {array} triggers [Array of node elements]
     * @return {void}
     */ $9be573a656cafbe3$var$_createClass(Modal, [
            {
                key: "registerTriggers",
                value: function registerTriggers() {
                    var _this = this;
                    for(var _len = arguments.length, triggers = new Array(_len), _key = 0; _key < _len; _key++)triggers[_key] = arguments[_key];
                    triggers.filter(Boolean).forEach(function(trigger) {
                        trigger.addEventListener("click", function(event) {
                            return _this.showModal(event);
                        });
                    });
                }
            },
            {
                key: "showModal",
                value: function showModal() {
                    var _this2 = this;
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    this.activeElement = document.activeElement;
                    this.modal.setAttribute("aria-hidden", "false");
                    this.modal.classList.add(this.config.openClass);
                    this.scrollBehaviour("disable");
                    this.addEventListeners();
                    if (this.config.awaitOpenAnimation) {
                        var handler = function handler() {
                            _this2.modal.removeEventListener("animationend", handler, false);
                            _this2.setFocusToFirstNode();
                        };
                        this.modal.addEventListener("animationend", handler, false);
                    } else this.setFocusToFirstNode();
                    this.config.onShow(this.modal, this.activeElement, event);
                }
            },
            {
                key: "closeModal",
                value: function closeModal() {
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var modal = this.modal;
                    this.modal.setAttribute("aria-hidden", "true");
                    this.removeEventListeners();
                    this.scrollBehaviour("enable");
                    if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
                    this.config.onClose(this.modal, this.activeElement, event);
                    if (this.config.awaitCloseAnimation) {
                        var openClass = this.config.openClass; // <- old school ftw
                        this.modal.addEventListener("animationend", function handler() {
                            modal.classList.remove(openClass);
                            modal.removeEventListener("animationend", handler, false);
                        }, false);
                    } else modal.classList.remove(this.config.openClass);
                }
            },
            {
                key: "closeModalById",
                value: function closeModalById(targetModal) {
                    this.modal = document.getElementById(targetModal);
                    if (this.modal) this.closeModal();
                }
            },
            {
                key: "scrollBehaviour",
                value: function scrollBehaviour(toggle) {
                    if (!this.config.disableScroll) return;
                    var body = document.querySelector("body");
                    switch(toggle){
                        case "enable":
                            Object.assign(body.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(body.style, {
                                overflow: "hidden"
                            });
                            break;
                    }
                }
            },
            {
                key: "addEventListeners",
                value: function addEventListeners() {
                    this.modal.addEventListener("touchstart", this.onClick);
                    this.modal.addEventListener("click", this.onClick);
                    document.addEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "removeEventListeners",
                value: function removeEventListeners() {
                    this.modal.removeEventListener("touchstart", this.onClick);
                    this.modal.removeEventListener("click", this.onClick);
                    document.removeEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "onClick",
                value: function onClick(event) {
                    if (event.target.hasAttribute(this.config.closeTrigger)) this.closeModal(event);
                }
            },
            {
                key: "onKeydown",
                value: function onKeydown(event) {
                    if (event.keyCode === 27) this.closeModal(event); // esc
                    if (event.keyCode === 9) this.retainFocus(event); // tab
                }
            },
            {
                key: "getFocusableNodes",
                value: function getFocusableNodes() {
                    var nodes = this.modal.querySelectorAll(FOCUSABLE_ELEMENTS);
                    return Array.apply(void 0, $9be573a656cafbe3$var$_toConsumableArray(nodes));
                }
            },
            {
                key: "setFocusToFirstNode",
                value: function setFocusToFirstNode() {
                    var _this3 = this;
                    if (this.config.disableFocus) return;
                    var focusableNodes = this.getFocusableNodes(); // no focusable nodes
                    if (focusableNodes.length === 0) return; // remove nodes on whose click, the modal closes
                    // could not think of a better name :(
                    var nodesWhichAreNotCloseTargets = focusableNodes.filter(function(node) {
                        return !node.hasAttribute(_this3.config.closeTrigger);
                    });
                    if (nodesWhichAreNotCloseTargets.length > 0) nodesWhichAreNotCloseTargets[0].focus();
                    if (nodesWhichAreNotCloseTargets.length === 0) focusableNodes[0].focus();
                }
            },
            {
                key: "retainFocus",
                value: function retainFocus(event) {
                    var focusableNodes = this.getFocusableNodes(); // no focusable nodes
                    if (focusableNodes.length === 0) return;
                    /**
         * Filters nodes which are hidden to prevent
         * focus leak outside modal
         */ focusableNodes = focusableNodes.filter(function(node) {
                        return node.offsetParent !== null;
                    }); // if disableFocus is true
                    if (!this.modal.contains(document.activeElement)) focusableNodes[0].focus();
                    else {
                        var focusedItemIndex = focusableNodes.indexOf(document.activeElement);
                        if (event.shiftKey && focusedItemIndex === 0) {
                            focusableNodes[focusableNodes.length - 1].focus();
                            event.preventDefault();
                        }
                        if (!event.shiftKey && focusableNodes.length > 0 && focusedItemIndex === focusableNodes.length - 1) {
                            focusableNodes[0].focus();
                            event.preventDefault();
                        }
                    }
                }
            }
        ]);
        return Modal;
    }();
    /**
   * Modal prototype ends.
   * Here on code is responsible for detecting and
   * auto binding event handlers on modal triggers
   */ // Keep a reference to the opened modal
    var activeModal = null;
    /**
   * Generates an associative array of modals and it's
   * respective triggers
   * @param  {array} triggers     An array of all triggers
   * @param  {string} triggerAttr The data-attribute which triggers the module
   * @return {array}
   */ var generateTriggerMap = function generateTriggerMap(triggers, triggerAttr) {
        var triggerMap = [];
        triggers.forEach(function(trigger) {
            var targetModal = trigger.attributes[triggerAttr].value;
            if (triggerMap[targetModal] === undefined) triggerMap[targetModal] = [];
            triggerMap[targetModal].push(trigger);
        });
        return triggerMap;
    };
    /**
   * Validates whether a modal of the given id exists
   * in the DOM
   * @param  {number} id  The id of the modal
   * @return {boolean}
   */ var validateModalPresence = function validateModalPresence(id) {
        if (!document.getElementById(id)) {
            console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(id, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it.");
            console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(id, '"></div>'));
            return false;
        }
    };
    /**
   * Validates if there are modal triggers present
   * in the DOM
   * @param  {array} triggers An array of data-triggers
   * @return {boolean}
   */ var validateTriggerPresence = function validateTriggerPresence(triggers) {
        if (triggers.length <= 0) {
            console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute.");
            console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>');
            return false;
        }
    };
    /**
   * Checks if triggers and their corresponding modals
   * are present in the DOM
   * @param  {array} triggers   Array of DOM nodes which have data-triggers
   * @param  {array} triggerMap Associative array of modals and their triggers
   * @return {boolean}
   */ var validateArgs = function validateArgs(triggers, triggerMap) {
        validateTriggerPresence(triggers);
        if (!triggerMap) return true;
        for(var id in triggerMap)validateModalPresence(id);
        return true;
    };
    /**
   * Binds click handlers to all modal triggers
   * @param  {object} config [description]
   * @return void
   */ var init = function init(config) {
        // Create an config object with default openTrigger
        var options = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, config); // Collects all the nodes with the trigger
        var triggers = $9be573a656cafbe3$var$_toConsumableArray(document.querySelectorAll("[".concat(options.openTrigger, "]"))); // Makes a mappings of modals with their trigger nodes
        var triggerMap = generateTriggerMap(triggers, options.openTrigger); // Checks if modals and triggers exist in dom
        if (options.debugMode === true && validateArgs(triggers, triggerMap) === false) return; // For every target modal creates a new instance
        for(var key in triggerMap){
            var value = triggerMap[key];
            options.targetModal = key;
            options.triggers = $9be573a656cafbe3$var$_toConsumableArray(value);
            activeModal = new Modal(options); // eslint-disable-line no-new
        }
    };
    /**
   * Shows a particular modal
   * @param  {string} targetModal [The id of the modal to display]
   * @param  {object} config [The configuration object to pass]
   * @return {void}
   */ var show = function show(targetModal, config) {
        var options = config || {};
        options.targetModal = targetModal; // Checks if modals and triggers exist in dom
        if (options.debugMode === true && validateModalPresence(targetModal) === false) return; // clear events in case previous modal wasn't close
        if (activeModal) activeModal.removeEventListeners(); // stores reference to active modal
        activeModal = new Modal(options); // eslint-disable-line no-new
        activeModal.showModal();
    };
    /**
   * Closes the active modal
   * @param  {string} targetModal [The id of the modal to close]
   * @return {void}
   */ var close = function close(targetModal) {
        targetModal ? activeModal.closeModalById(targetModal) : activeModal.closeModal();
    };
    return {
        init: init,
        show: show,
        close: close
    };
}();
window.MicroModal = $9be573a656cafbe3$var$MicroModal;
var $9be573a656cafbe3$export$2e2bcd8739ae039 = $9be573a656cafbe3$var$MicroModal;

});


})();
//# sourceMappingURL=contact.ab53e317.js.map
